import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import {
  Row,
  Col,
  Form,
  Upload,
  Breadcrumb,
  Select,
  Space,
  Input,
  Spin,
  Radio,
  Button,
  AutoComplete,
  Collapse,
  Tooltip,
  Checkbox,
  message,
  Layout,
  Modal,
  Table,
  Popconfirm,
} from "antd";
import {
  DeleteOutlined,
  MinusSquareFilled,
  PlusSquareFilled,
  PercentageOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  SaveOutlined,
  EditOutlined,
} from "@ant-design/icons";
import "antd/dist/antd.min.css";
import "../../styles/Main.scss";
import verifybtn from "../../image/verifybtn.png";
import InputField from "../../common/htmlComponents/InputField";
import EmailField from "../../common/htmlComponents/EmailField";
import TextAreaField from "../../common/htmlComponents/TextAreaField";
import { ReactComponent as User } from "../../image/User.svg";
import { ReactComponent as Vector } from "../../image/Vector.svg";
import { ReactComponent as AddressLine } from "../../image/AddressLine.svg";
import { ReactComponent as Email } from "../../image/Email.svg";
import { ReactComponent as Archiveicon } from "../../image/Archiveicon.svg";
import SearchIcon from "../../image/SearchIcon.svg";
import { ReactComponent as Name } from "../../image/Name.svg";
import { ReactComponent as City } from "../../image/City.svg";
import { ReactComponent as IdcardOutlined } from "../../image/IdcardOutlined.svg";
import { ReactComponent as ZipCode } from "../../image/ZipCode.svg";
import { ReactComponent as Website } from "../../image/Website.svg";
import { ReactComponent as About } from "../../image/About.svg";
import { ReactComponent as FileImageOutlined } from "../../image/FileImageOutlined.svg";
import { ReactComponent as FileAlt } from "../../image/FileAlt.svg";
// import { ReactComponent as Editicon } from "../../image/Editicon.svg";
import { authUserData } from "../../utils/Helper";
import {
  deleteRequest,
  getRequest,
  patchRequest,
  postRequest,
} from "../../axios";
import ButtonField from "../../common/htmlComponents/ButtonField";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
  WarningNotificationMsg,
} from "../../utils/Notifications";
import VendorDocumentGrid from "../../feature/vendor/VendorDocumentGrid";
import { debounce } from "lodash";
import KeyPersonVendor from "../../feature/vendor/KeyPersonVendor";
import InquiryValueVendor from "../../feature/vendor/InquiryValueVendor";
import BankDetailsVendor from "../../feature/vendor/BankDetailsVendor";
import AssignSiteVendor from "../../feature/vendor/AssignSiteVendor";
import PaymentVendor from "../../feature/vendor/PaymentVendor";
import VendorDocumentField from "../../feature/vendor/VendorDocumentField";
import VendorLogoUpload from "../../feature/vendor/VendorLogoUpload";
import CommunicationMatrixVendor from "../../feature/vendor/CommunicationMatrixVendor";
import PaymentPersonReleasedField from "../../feature/vendor/PaymentPersonReleasedField";
import AssignCityVendorStep from "../../authentication/steps/AssignCityVendorStep";
import StepInquiryValueVendor from "../../authentication/steps/StepInquiryValueVendor";
import { Content } from "antd/lib/layout/layout";
import SupplierBillingDetails from "../../feature/vendor/SupplierBillingDetails";
import InquiryValue from "./InquiryValue";
import AssignCityVendor from "./AssignCityVendor";
import BankDetailsMyVendor from "./BankDetailsMyVendor";
import PaymentMyVendor from "./PaymentMyVendor";
import PhoneOtpVerify from "../../authentication/PhoneOtpVerify";
import VerifyOtpModal from "../../authentication/VerifyOtpModel";
import WhomToIntimateVendor from "./WhomToIntimateVendor";

const { Option } = Select;

const MyVendor = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const deliveryFormRef = useRef();
  const vendorLoginId = authUserData()?.vendor;
  const { Search } = Input;
  const [form] = Form.useForm();
  const VendorId = id ? id : null;
  const CompanyId = authUserData()?.company ? authUserData()?.company : null;
  const userId = authUserData()?.user_id ? authUserData()?.user_id : null;
  const [btnLoadingVerifyGst, setBtnLoadingVerifyGst] = useState(false);
  const formRef = useRef();
  const initialDocument = { vendor_company: null, document_name: null };
  const [verifyEmailButtonView, setVerifyEmailButtonView] = useState(true);
  const { Panel } = Collapse;
  const [stateDropdownOptions, setStateDropdownOptions] = useState([]);
  const [verificationResultGST, setVerificationResultGST] = useState(null);
  const [verificationResultPancard, setVerificationResultPancard] =
    useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [verifyGstButtonView, setVerifyGstButtonView] = useState(true);
  const [selectedRow, setSelectedRow] = useState([]);
  const [verifyAdhaar, setVerifyAdhaar] = useState(false);
  const [verificationStatus, setVerificationStatus] = useState(null);
  const [verifyGstDisable, setVerifyDisable] = useState(true);
  const [isModalOpenPhone, setIsModalOpenPhone] = useState(false);
  const [verificationResultContact, setVerificationResultContact] =
    useState(null);
  const [verificationResultEmail, setVerificationResultEmail] = useState(null);
  const [verificationResultAdhaar, setVerificationResultAadhaar] =
    useState(null);
  const [btnLoadingAdhaar, setBtnLoadingAdhaar] = useState(false);
  const [verifyAdhaarButtonView, setVerifyAdhaarButtonView] = useState(true);
  const [verifyPhoneButtonView, setVerifyPhoneButtonView] = useState(true);
  const [OTP, setOTP] = useState(null);
  const [OTPPhone, setOTPPhone] = useState(null);
  const [minutes, setMinutes] = useState(1);
  const [seconds, setSeconds] = useState(0);
  const [minutesPhone, setMinutesPhone] = useState(1);
  const [secondsPhone, setSecondsPhone] = useState(0);
  const [deliveryRateLoading, setDeliveryRateLoading] = useState(false);
  const [btnDisplay, setBtnDisplay] = useState("Add");
  const [btnLoadingFile, setBtnLoadingFile] = useState(false);
  const [vendorMatrixSteps, setVendorMatrixSteps] = useState([]);
  const [vendorCommunicationId, setVendorCommunicationId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [reload, setReload] = useState(false);
  const [vendorCommunicationList, setVendorCommunicationList] = useState([]);
  const initialState = {
    vendor_registered_name: null,
    person_name: null,
    designation: null,
    website: null,
    no_of_employees: null,
    company_pan: null,
    gst_no: null,
    email: null,
    phone: null,
    lut_number: null,
    msme: false,
    msme_number: null,
    vendor_trade_name: null,
    email_verified: false,
    phone_verified: false,
    udyam_aadhaar_no_verified: false,
    gst_no_verified: false,
    registered_business_address_building: null,
    registered_business_address_area: null,
    registered_business_address_landmark: null,
    registered_business_address_state: null,
    registered_business_address_city: null,
    registered_business_address_pincode: null,
    trading_address_building: null,
    trading_address_area: null,
    trading_address_landmark: null,
    trading_address_state: null,
    trading_address_city: null,
    trading_address_pincode: null,
    same_as_registered_business_address: false,

    vendor_inquiry_value: [
      {
        company: CompanyId,
        category_tree: 1,
        company_material_type: null,
        minimum_inquiry_value: null,
        maximum_inquiry_value: null,
        city: [],
      },
    ],
    // assign_city_to_vendor: [
    //   {
    //     company: CompanyId,
    //     category_tree: 1,
    //     material_type: null,
    //     city: [],
    //   },
    // ],
    vendor_company_code: {
      company: CompanyId,
      vendor_code_by_company: null,
    },
  };
  const initialVendorCommunicationState = {
    company: null,
    vendor_matrix_steps: [],
    name: null,
    email: null,
    designation: null,
    phone_number: null,
  };
  const [state, setState] = useState(initialState);
  const [stateTable, setStateTable] = useState({
    page: 1,
    ordering: "-id",
    pagesize: 10,
    search: "",
    total: 0,
  });
  const [totalCount, settotalCount] = useState(0);
  const [vendorCommunicationState, setVendorCommunicationState] = useState(
    initialVendorCommunicationState
  );
  const [addedCompanyId, setAddedCompanyId] = useState(null);
  const [stateDropdownOptionsShipping, setShippingState] = useState([]);
  const [pincodeListBillingRegistered, setPincodeListBillingRegistered] =
    useState([]);
  const [searchValueBilling, setSearchValueBilling] = useState("");
  const [pincodeListShipping, setPincodeListShipping] = useState([]);
  const [searchValueShipping, setSearchValueShipping] = useState("");
  const [documentState, setDocumentState] = useState(initialDocument);
  const [isGstNoReadOnly, setIsGstNoReadOnly] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [btnLoadingPhone, setBtnLoadingPhone] = useState(false);
  const [btnLoadingEmail, setBtnLoadingEmail] = useState(false);
  const [btnLoadingPan, setBtnLoadingPan] = useState(false);
  const [apiLoading, setapiloading] = useState(false);
  const [pincodeList, setPincodeList] = useState([]);
  const [categoryTree, setCategoryTree] = useState([]);
  const [categoryTreeCity, setCategoryTreeCity] = useState([]);
  const [size, setSize] = useState(null);
  const [sizeOne, setSizeOne] = useState(null);
  const [uploadFile, setUploadFile] = useState("");
  const [fileLink, setFileLink] = useState(null);
  const [fileName, setFileName] = useState(null);
  const [uploadFileOne, setUploadFileOne] = useState("");
  const [fileLinkOne, setFileLinkOne] = useState(null);
  const [fileNameOne, setFileNameOne] = useState(null);
  const [selectedOption, setSelectedOption] = useState("");
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [addedVendorId, setAddedVendorId] = useState(null);
  const [gstVendorId, setgstVendorId] = useState(null);
  const [vendorDocumentList, setVendorDocumentList] = useState(null);
  const [refreshGrid, setRefreshGrid] = useState(false);
  const [vendorDocumentId, setVendorDocumentId] = useState(null);
  const [siteEmployee, setSiteEmployee] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [postGeneratedVendorId, setPostGeneratedVendorId] = useState(null);
  const [postGeneratedCompanyId, setPostGeneratedCompanyId] = useState(null);
  const [keyPersonId, setKeyPersonId] = useState(null);
  const [paymentReleasedId, setPaymentReleasedId] = useState(null);
  const [communicationMatrixId, setCommunicationMatrixId] = useState(null);
  const [bankDetailId, setBankDetailId] = useState(null);
  const [assignSiteId, setAssignSiteId] = useState(null);
  const [supplierBillingId, SetSupplierBillingId] = useState(null);
  const [paymentTermsId, setPaymentTermsId] = useState(null);
  const [inquiryValueId, setInquiryValueId] = useState(null);
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [materialType, setMaterialType] = useState([]);
  const [siteList, setSiteList] = useState([]);
  const [gstValue, setGstValue] = useState(null);
  const [companyList, setCompanyList] = useState(false);
  const url = state.msme_document;
  const [showKeyPersonCollapse, setShowKeyPersonCollapse] = useState(false);
  const [showVendorCommunicationCollapse, setShowVendorCommunicationCollapse] =
    useState(false);
  const [showBankDetailsCollapse, setShowBankDetailsCollapse] = useState(false);
  const [showAssignSiteCollapse, setShowAssignSiteCollapse] = useState(false);
  const [showPaymentCollapse, setShowPaymentCollapse] = useState(false);
  const [identifyProfileUrl, setIdentifyProfileUrl] = useState(null);
  const [uploadFileProfilePic, setUploadFileProfilePic] = useState("");
  const [fileList, setFileList] = useState([]);
  const [disabledOptions, setDisabledOptions] = useState([]);
  const [disabledOptionsCity, setDisabledOptionsCity] = useState([]);
  const [cityDropdownOptionsShipping, setCityShipping] = useState([]);
  const [venId, setVenId] = useState(null);
  const [cityDropdownOptionsAddVendor, setCityDropdownOptionsAddVendor] =
    useState([]);
  const [cityDropdownOptions, setCityDropdownOptions] = useState([]);
  const [tradingCityDropdownOptions, setTradingCityDropdownOptions] = useState(
    []
  );
  const [showPaymentPersonReleasedField, setShowPaymentPersonReleasedField] =
    useState(false);
  const [showVendorBillingDetails, setShowVendorBillingDetails] =
    useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const handleCloneInputChange = (field, e, index) => {
    let newPersonArr = state.suppliers_billing_details;
    newPersonArr[index][field] = e.target.value ? e.target.value : null;
    setState({ ...state, suppliers_billing_details: newPersonArr });
  };
  const handleInputAdhaarChange = (e) => {
    let { name, value } = e.target;
    setVerificationResultAadhaar("");
    setVerifyAdhaar(true);
    setVerifyAdhaarButtonView(true);
    setState({
      ...state,
      udyam_aadhaar_no: value !== "" ? value : null,
      udyam_aadhaar_no_verified: false,
    });
  };
  const handleAdhaarNumberVerify = async () => {
    try {
      const adhaarNumber = state?.udyam_aadhaar_no;

      if (adhaarNumber) {
        setBtnLoadingAdhaar(true);
        const response = await getRequest(
          `/doc-verification/udhyam/?udhyam_no=${adhaarNumber}`
        );
        if (response.data.results.data) {
          SuccessNotificationMsg("Udyam Number verified successfully");
          setVerificationResultAadhaar("success");
          setBtnLoadingAdhaar(false);
        } else {
          ErrorNotificationMsg(t("Invalid number"));
          setBtnLoadingAdhaar(false);
          setVerificationResultAadhaar("error");
        }
      }
    } catch (error) {
      ErrorNotificationMsg(t("Error in verifying number"));
      setBtnLoadingAdhaar(false);
      setVerificationResultAadhaar("error");
    }
  };
  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearchVendorCommunication);
  };

  const onSearchVendorCommunication = (value) => {
    setStateTable({
      ...stateTable,
      search: value,
    });
  };
  const debounceLoadData = debounce((value, onSearchVendorCommunication) => {
    onSearchVendorCommunication(value);
  }, 1000);
  // const handleEditIconClick = (id) => {
  //   setVendorCommunicationId(id);

  //   setBtnDisplay("Edit");
  // };

  const handleEditIconClick = async (id) => {
    setVendorCommunicationId(id);
    setBtnDisplay("Edit");

    try {
      const apiResponse = await getRequest(`vendor-communication-matrix/${id}`);

      if (apiResponse.data.success) {
        const existingData = apiResponse.data.data;
        console.log("existingData666", existingData);

        deliveryFormRef.current.setFieldsValue({
          company: existingData.company_name,
          vendor_name: existingData.vendor_name,
          name: existingData.name,
          email: existingData.email,
          designation: existingData.designation,
          phone_number: existingData.phone_number,
          vendor_matrix_steps: existingData.vendor_matrix_steps.map(
            (step) => step.id
          ),
        });
        setVendorCommunicationState(existingData);
      } else {
        console.error("Error fetching data");
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const handleCompanyChange = (value) => {
    setVendorCommunicationState((prevState) => {
      return {
        ...prevState,
        company: value,
      };
    });
  };
  const handleVendorMatrixStepsChange = (value) => {
    setVendorCommunicationState((prevState) => {
      return {
        ...prevState,
        vendor_matrix_steps: value,
      };
    });
  };
  const handleArchive = async (id = []) => {
    let ids = selectedRow;
    // if (ids.length === 0) {
    //   ids.push(id);
    // }
    // try {
    //   let apiResponse = await deleteRequest(
    //     "driver-delivery-rate/driver-delivery-rate-delete/",
    //     {
    //       deleted: ids,
    //     }
    //   );
    //   if (apiResponse.data.success) {
    //     SuccessNotificationMsg(t("Delivery Rate Deleted Successfully"));
    setReload(!reload);
    //     setSelectedRow([]);
    //   } else {
    //     ErrorNotificationMsg(t("Error In Delivery Rate"));
    //   }
    // } catch (error) {
    //   console.log("");
    // }
  };
  const handleReset = () => {
    // setDocumentState({
    //   company: "",
    //   weight_start: "",
    //   start_unit_of_measurement: "",
    //   weight_end: "",
    //   end_unit_of_measurement: "",
    //   rate: "",
    //   currency: "",
    // });
    setVendorCommunicationState({
      company: "",
      name: "",
      email: "",
      phone_number: "+91",
      vendor_matrix_steps: [],
      designation: "",
    });
    deliveryFormRef.current.setFieldsValue({
      company: [],
      vendor_name: "",
      name: "",
      email: "",
      designation: "",
      phone_number: "+91",
      vendor_matrix_steps: [],
    });
  };
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
    setOTP(null);
    setSeconds(30);
    setMinutes(1);
    setBtnLoadingEmail(false);
  };
  const showModalPhone = () => {
    setIsModalOpenPhone(true);
  };
  const handleOkPhone = () => {
    setIsModalOpenPhone(false);
  };
  const handleCancelPhone = () => {
    setIsModalOpenPhone(false);
    setOTPPhone(null);
    setSecondsPhone(30);
    setMinutesPhone(1);
    setBtnLoadingPhone(false);
  };
  const handleGstNumberVerify = async () => {
    setVerifyDisable(true);
    setVerifyGstButtonView(true);
    try {
      setBtnLoadingVerifyGst(true);
      const gst = state?.gst_no;

      const response = await getRequest(`doc-verification/gst/?gst_no=${gst}`);
      if (response.data.results.data) {
        SuccessNotificationMsg("GST verified successfully");
        setVerificationStatus("success");
        setBtnLoadingVerifyGst(false);
        setVerifyGstButtonView(false);
      } else {
        ErrorNotificationMsg(t("Invalid GST No."));
        setBtnLoadingVerifyGst(false);
        setVerifyDisable(false);
        setVerifyGstButtonView(true);
      }
    } catch (error) {
      ErrorNotificationMsg(t("Error in verifying GST number"));
      setVerifyDisable(false);
      setBtnLoadingVerifyGst(false);
      setVerifyGstButtonView(true);
    }
  };

  const handleVendorCommunicationSubmit = async () => {
    const { company, name, email, phone_number, vendor_matrix_steps } =
      vendorCommunicationState;

    if (
      !company ||
      !name ||
      !email ||
      !phone_number ||
      !vendor_matrix_steps ||
      vendor_matrix_steps.length === 0
    ) {
      const missingFields = [];
      if (!company) missingFields.push(t("Company"));
      if (!name) missingFields.push(t("Name"));
      if (!email) missingFields.push(t("Email"));
      if (!phone_number) missingFields.push(t("Phone Number"));
      if (!vendor_matrix_steps || vendor_matrix_steps.length === 0)
        missingFields.push(t("Communication Step"));

      ErrorNotificationMsg(
        t("Please fill the following required fields: ") +
          missingFields.join(", ")
      );
      return;
    }

    const payload = {
      vendor_communication_matrix: [
        {
          company: vendorCommunicationState?.company,
          vendor_matrix_steps: vendorCommunicationState?.vendor_matrix_steps
            ? vendorCommunicationState?.vendor_matrix_steps
            : [],
          name: vendorCommunicationState?.name,
          email: vendorCommunicationState?.email,
          designation: vendorCommunicationState?.designation,
          phone_number: vendorCommunicationState?.phone_number,
        },
      ],
    };
    // console.log(
    //   "vendorCommunicationState?.vendor_matrix_steps",
    //   vendorCommunicationState?.vendor_matrix_steps
    // );

    let ids = [];

    if (vendorCommunicationState?.vendor_matrix_steps[0]?.id) {
      vendorCommunicationState?.vendor_matrix_steps.map((id) => {
        ids.push(id.id);
      });
    } else {
      ids = vendorCommunicationState?.vendor_matrix_steps.map((id) => {
        return id;
      });
    }

    const payload2 = {
      vendor_communication_matrix: [
        {
          company: vendorCommunicationState?.company,
          vendor_matrix_steps: vendorCommunicationState?.vendor_matrix_steps
            ? ids
            : [],
          name: vendorCommunicationState?.name,
          email: vendorCommunicationState?.email,
          designation: vendorCommunicationState?.designation,
          phone_number: vendorCommunicationState?.phone_number,
        },
      ],
    };

    try {
      setBtnLoadingFile(true);
      let apiResponse;
      if (vendorCommunicationId === null) {
        apiResponse = await postRequest(
          "vendor-communication-matrix/add-single-vendor-communication-matrix/",
          payload
        );
      } else {
        apiResponse = await patchRequest(
          `vendor-communication-matrix/update-single-vendor-communication-matrix/?matrix_id=${vendorCommunicationId}`,
          payload2
        );
      }
      if (apiResponse.data.success === true) {
        handleRefreshGrid();
        SuccessNotificationMsg(
          vendorCommunicationId === null
            ? t("Vendor Communication Matrix Added Successfully")
            : t("Vendor Communication Matrix Updated Successfully")
        );
        setVendorCommunicationId(null);
        setBtnDisplay("Add");
        setBtnLoadingFile(false);
        handleReset();
      }
      setBtnLoading(false);
    } catch (error) {
      setBtnLoading(false);
      setBtnLoadingFile(false);
      ErrorNotificationMsg(t("Error in submitting the form"));
      // ErrorNotificationMsg(t("Error in verifying number"));
      // ErrorNotificationMsg(rulesMessage);
    }
  };
  const columns = [
    {
      title: "Company",
      dataIndex: "company_name",
      key: "company_name",
      sorter: true,
    },
    {
      title: "Vender Code as per Company ERP System",
      dataIndex: "vendor_code_by_company",
      key: "vendor_code_by_company",
      sorter: true,
    },
  ];
  const columnsInquiryValue = [
    {
      title: "Company",
      dataIndex: "company_name",
      key: "company_name",
      sorter: true,
    },
    {
      title: "Material Type",
      dataIndex: "company_material_type",
      key: "company_material_type",
      sorter: true,
      render: (company_material_type) =>
        company_material_type.map((s) => s.name).join(", "),
    },
    {
      title: "City",
      dataIndex: "city",
      key: "name",
      sorter: true,
      render: (city) => city.map((s) => s.name).join(", "),
    },
    {
      title: "Minimum Inquiry Value",
      dataIndex: "minimum_inquiry_value",
      key: "minimum_inquiry_value",
      sorter: true,
    },
    {
      title: "Maximum Inquiry Value",
      dataIndex: "maximum_inquiry_value",
      key: "maximum_inquiry_value",
      sorter: true,
    },
  ];
  const columnsAssignCity = [
    {
      title: "Company",
      dataIndex: "company_name",
      key: "company_name",
      sorter: true,
    },
    {
      title: "Material Type",
      dataIndex: "material_type_name",
      key: "material_type_name",
      sorter: true,
    },
    {
      title: "Town/City",
      dataIndex: "city",
      key: "city",
      sorter: true,
      render: (city) => city.map((s) => s.city_name).join(", "),
    },
  ];
  const columnsSupplierBillingDetails = [
    {
      title: "Company",
      dataIndex: "company_name",
      key: "company_name",
      sorter: true,
    },
    {
      title: "Vendor GST For Billing",
      dataIndex: "gst_for_billing",
      key: "gst_for_billing",
      sorter: true,
    },
    {
      title: "Shop No., Building, Apartment",
      dataIndex: "address_line_1",
      key: "address_line_1",
      sorter: true,
    },
    {
      title: "Area, Street",
      dataIndex: "address_line_2",
      key: "address_line_2",
      sorter: true,
    },
    {
      title: "Person Name",
      dataIndex: "person_name",
      key: "person_name",
      sorter: true,
    },
    {
      title: "Landmark",
      dataIndex: "landmark",
      key: "landmark",
      sorter: true,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      sorter: true,
    },
    {
      title: "Contact Number",
      dataIndex: "mobile_number",
      key: "mobile_number",
      sorter: true,
    },
    {
      title: "Pin Code",
      dataIndex: "pincode_number",
      key: "pincode_number",
      sorter: true,
    },
    {
      title: "Town/City",
      dataIndex: "city",
      key: "city",
      sorter: true,
    },
    {
      title: "State/Province",
      dataIndex: "state",
      key: "state",
      sorter: true,
    },
  ];
  const columnsBankDetails = [
    {
      title: "Account Holder Name",
      dataIndex: "account_holder_name",
      key: "account_holder_name",
      sorter: true,
    },
    {
      title: "Account Number",
      dataIndex: "account_number",
      key: "account_number",
      sorter: true,
    },
    {
      title: "Bank Name",
      dataIndex: "bank_name",
      key: "bank_name",
      sorter: true,
    },
    {
      title: "Branch Name",
      dataIndex: "branch_name",
      key: "branch_name",
      sorter: true,
    },
    {
      title: "IFSC Code",
      dataIndex: "ifsc_code",
      key: "ifsc_code",
      sorter: true,
    },
    {
      title: "GSTN",
      dataIndex: "gstn",
      key: "gstn",
      sorter: true,
    },
  ];
  const columnsPayment = [
    {
      title: "Days To Pay",
      dataIndex: "days_to_pay",
      key: "days_to_pay",
      sorter: true,
    },
    {
      title: "When To Pay",
      dataIndex: "when_to_pay",
      key: "when_to_pay",
      sorter: true,
    },
    {
      title: "From When To Calculate",
      dataIndex: "when_to_calculate",
      key: "when_to_calculate",
      sorter: true,
    },
    {
      title: "Advance in %",
      dataIndex: "advance",
      key: "advance",
      sorter: true,
    },
    {
      title: "Select payment security type",
      dataIndex: "payment_security_type",
      key: "payment_security_type",
      sorter: true,
    },
  ];
  const columnsPaymentReleased = [
    {
      title: "Person Name",
      dataIndex: "person_name",
      key: "person_name",
      sorter: true,
    },
    {
      title: "Designation",
      dataIndex: "designation",
      key: "designation",
      sorter: true,
    },
    {
      title: "Department",
      dataIndex: "department",
      key: "department",
      sorter: true,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      sorter: true,
    },
    {
      title: "Contact Number",
      dataIndex: "contact_number",
      key: "contact_number",
      sorter: true,
    },
  ];
  const columnsCommunicationMatrix = [
    {
      title: "Sr.",
      key: "sr_no",
      render: (text, record, index) => index + 1,
      width: 60,
    },
    {
      title: "Company",
      dataIndex: "company_name",
      key: "company_name",
      sorter: true,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      sorter: true,
    },
    {
      title: "Person Name",
      dataIndex: "name",
      key: "name",
      sorter: true,
    },
    {
      title: "Designation",
      dataIndex: "designation",
      key: "designation",
      sorter: true,
    },
    {
      title: "Contact Number",
      dataIndex: "phone_number",
      key: "phone_number",
      sorter: true,
    },
    {
      title: "Communication Step",
      dataIndex: "vendor_matrix_steps",
      key: "vendor_matrix_steps",
      sorter: true,
      render: (vendor_matrix_steps) =>
        vendor_matrix_steps.map((s) => s.name).join(", "),
    },
    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 150,
      render: (text, record) => (
        <Space>
          <EditOutlined
            onClick={() => handleEditIconClick(record.id)}
            style={{ cursor: "pointer", fontSize:'15px' }}
          />

          <Popconfirm
            className="action"
            title={t("pop_delete")}
            okText={t("pop_ok")}
            cancelText={t("pop_cancel")}
            onConfirm={() => handleDeleteRecord(record?.id)}
          >
            <DeleteOutlined
              style={{ cursor: "pointer", fontSize:'15px'}}
              // onConfirm={() => handleDeleteRecord(record?.id)}
            />
          </Popconfirm>
        </Space>
      ),
    },
  ];
  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });
  };
  const handleTableChangeVendorCommunication = async (
    pagination,
    filters,
    sorter,
    ordering
  ) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setStateTable({
      ...stateTable,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });
  };
  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";
    if (sortField === "company" && sortOrder === "ascend") {
      sortingEnumKey = "company__company_name";
    }
    if (sortField === "company" && sortOrder === "descend") {
      sortingEnumKey = "-company__company_name";
    }
    if (sortField === "weight_start" && sortOrder === "ascend") {
      sortingEnumKey = "weight_start";
    }
    if (sortField === "weight_start" && sortOrder === "descend") {
      sortingEnumKey = "-weight_start";
    }
    if (sortField === "start_unit_of_measurement" && sortOrder === "ascend") {
      sortingEnumKey = "start_unit_of_measurement__name";
    }
    if (sortField === "start_unit_of_measurement" && sortOrder === "descend") {
      sortingEnumKey = "-start_unit_of_measurement__name";
    }
    if (sortField === "weight_end" && sortOrder === "ascend") {
      sortingEnumKey = "weight_end";
    }
    if (sortField === "weight_end" && sortOrder === "descend") {
      sortingEnumKey = "-weight_end";
    }
    if (sortField === "end_unit_of_measurement" && sortOrder === "ascend") {
      sortingEnumKey = "end_unit_of_measurement__name";
    }
    if (sortField === "end_unit_of_measurement" && sortOrder === "descend") {
      sortingEnumKey = "-end_unit_of_measurement__name";
    }
    if (sortField === "rate" && sortOrder === "ascend") {
      sortingEnumKey = "rate";
    }
    if (sortField === "rate" && sortOrder === "descend") {
      sortingEnumKey = "-rate";
    }
    if (sortField === "currency" && sortOrder === "ascend") {
      sortingEnumKey = "currency";
    }
    if (sortField === "currency" && sortOrder === "descend") {
      sortingEnumKey = "-currency";
    }

    return sortingEnumKey;
  };

  const rowSelection = {
    onChange: (selectedRowKeys) => {
      setSelectedRow(selectedRowKeys);
    },
  };
  const [sameAsRegisteredBusinessAddress, setSameAsRegisteredBusinessAddress] =
    useState(false);

  let filename = "";
  let filenameone = "";
  try {
    if (fileLink) {
      filename = url.split("/").pop();
    }
  } catch (e) {
    filename = "";
  }
  const onChange = (key) => {
    console.log(key);
  };

  const [companycode, setVendorcompanyCode] = useState([]);
  const [companyInquiryValue, setCompanyInquiryValue] = useState([]);
  const [companyassigncity, setCompanyAssignCity] = useState([]);
  const [companyBankDetails, setCompanyBankDetails] = useState([]);
  const [companypaymentterms, setCompanyPaymentTerms] = useState([]);
  const [companyPaymentReleased, setCompanyPaymentReleased] = useState([]);
  const [
    companycolumnsCommunicationMatrix,
    setCompanycolumnsCommunicationMatrix,
  ] = useState([]);
  const [companysupplierbillingdetails, setCompanySupplierBillingDetails] =
    useState([]);
  const vendorId = authUserData()?.vendor ? authUserData()?.vendor : null;
  useEffect(() => {
    const getVendorOnboarding = async () => {
      setapiloading(true);
      try {
        const apiResponse = await getRequest(
          `vendor/${vendorId}/get-vendor-details/`
        );
        setShowKeyPersonCollapse(true);
        setShowVendorCommunicationCollapse(true);
        setShowAssignSiteCollapse(true);
        // setShowPaymentCollapse(true);
        setVendorcompanyCode(apiResponse.data.data.vendor_company_code);
        setCompanyInquiryValue(apiResponse.data.data.inquiry_value);
        setCompanyAssignCity(apiResponse.data.data.assign_city);
        setCompanyBankDetails(apiResponse.data.data.bankdetails);
        setCompanyPaymentTerms(apiResponse.data.data.company_payment_terms);
        setCompanyPaymentReleased(apiResponse.data.data.payment_released);
        setCompanycolumnsCommunicationMatrix(
          apiResponse.data.data.vendor_communication_matrix_data
        );
        setCompanySupplierBillingDetails(
          apiResponse.data.data.suppliers_billing_details
        );
        setVenId(apiResponse.data.data.id);
        if (apiResponse.data.success) {
          const {
            unique_code,
            id,
            company_payment_terms,
            keypersons,
            bankdetails,
            suppliers_billing_details,
            assign_city,
            inquiry_value,
            vendor_company_code,
            ...filteredResponse
          } = apiResponse.data.data;
          if (
            apiResponse.data.data.trading_address_state !== null &&
            apiResponse.data.data.trading_address_state !== undefined &&
            apiResponse.data.data.trading_address_state !== ""
          ) {
            //getCityByStateTrading(apiResponse.data.data.trading_address_state);
          }
          if (
            apiResponse.data.data.registered_business_address_state !== null &&
            apiResponse.data.data.registered_business_address_state !==
              undefined &&
            apiResponse.data.data.registered_business_address_state !== ""
          ) {
            // getCityByStateForShipping(
            //   apiResponse.data.data.registered_business_address_state
            // );
          }

          setState({
            ...filteredResponse,
            // assign_city_to_vendor: apiResponse.data.data.assign_city.map(
            //   (assigncity) => {
            //     const {
            //       id,
            //       vendor,
            //       vendor_name,

            //       category_tree,
            //       category_tree_name,
            //       company_name,
            //       company,
            //       material_type,
            //       material_type_name,
            //       city_name,
            //       city,
            //       ...rest
            //     } = assigncity;

            //     return {
            //       id,
            //       vendor,
            //       vendor_name,
            //       category_tree,
            //       category_tree_name,
            //       company_name,
            //       company,
            //       material_type,
            //       material_type_name,
            //       // city: city.map((ci) => ci.city_id),
            //       // city_name: city[0].city_name,
            //       ...rest,
            //     };
            //   }
            // ),
            vendor_inquiry_value: apiResponse.data.data.inquiry_value.map(
              (inquiry) => {
                const {
                  // id,
                  vendor,
                  vendor_name,
                  category_tree_name,
                  company_name,
                  company,
                  city_name,
                  city,
                  ...rest
                } = inquiry;

                return {
                  company: CompanyId,
                  // city: city.map((ci) => ci.city_id),
                  // city_name: city[0].city_name,
                  ...rest,
                };
              }
            ),
            vendor_company_code: {
              id: apiResponse.data.data.vendor_company_code[0].id,
              vendor: vendorId,
              vendor_code_by_company:
                apiResponse.data.data.vendor_company_code[0]
                  .vendor_code_by_company,
            },
          });

          const newItem = apiResponse.data.data.inquiry_value.map((item) => {
            return item.category_tree;
          });
          setDisabledOptions(newItem);

          setPostGeneratedVendorId(apiResponse.data.data.id);
          setPostGeneratedCompanyId(
            apiResponse?.data?.data?.vendor_company_code[0]?.company
          );
          setFileLink(apiResponse.data.data.msme_document);
          if (apiResponse.data.data.keypersons.length > 0) {
            const keyPersonId =
              apiResponse.data.data.keypersons[0].id !== null
                ? apiResponse.data.data.keypersons[0].id
                : null;

            setKeyPersonId(keyPersonId);
            setShowVendorBillingDetails(keyPersonId !== null);
          } else {
            setKeyPersonId(null);
            setShowVendorBillingDetails(false);
          }
          if (apiResponse.data.data.payment_released.length > 0) {
            const paymentReleasedId =
              apiResponse.data.data.payment_released[0].id !== null
                ? apiResponse.data.data.payment_released[0].id
                : null;
            setPaymentReleasedId(paymentReleasedId);
          } else {
            setPaymentReleasedId(null);
          }
          const bankDetailId =
            apiResponse.data.data.bankdetails[0].id !== null
              ? apiResponse.data.data.bankdetails[0].id
              : null;
          setBankDetailId(bankDetailId);
          setShowPaymentCollapse(bankDetailId !== null);

          const supplierBillingId =
            apiResponse.data.data.suppliers_billing_details[0].id !== null
              ? apiResponse.data.data.suppliers_billing_details[0].id
              : null;
          SetSupplierBillingId(supplierBillingId);
          setShowBankDetailsCollapse(supplierBillingId !== null);

          const communicationMatrixId =
            apiResponse.data.data.vendor_communication_matrix_data[0].id !==
            null
              ? apiResponse.data.data.vendor_communication_matrix_data[0].id
              : null;
          setCommunicationMatrixId(communicationMatrixId);
          const paymentTermsId =
            apiResponse.data.data.company_payment_terms[0].id !== null
              ? apiResponse.data.data.company_payment_terms[0].id
              : null;
          setPaymentTermsId(paymentTermsId);
          setShowPaymentPersonReleasedField(paymentTermsId !== null);

          formRef.current.setFieldsValue({
            ...apiResponse.data.data,
            lut_number: apiResponse.data.data.lut_number,
            vendor_trade_name: apiResponse.data.data.vendor_trade_name,
            vendor_registered_name:
              apiResponse.data.data.vendor_registered_name,
            registered_business_address_building:
              apiResponse?.data?.data?.registered_business_address_building,
            registered_business_address_area:
              apiResponse?.data?.data?.registered_business_address_area,
            registered_business_address_landmark:
              apiResponse?.data?.data?.registered_business_address_landmark,
            registered_business_address_state:
              apiResponse?.data?.data?.registered_business_address_state,
            registered_business_address_city:
              apiResponse?.data?.data?.registered_business_address_city,
            registered_business_address_pincode:
              apiResponse?.data?.data
                ?.registered_business_address_pincode_number,
            trading_address_building:
              apiResponse?.data?.data?.trading_address_building,
            trading_address_area: apiResponse?.data?.data?.trading_address_area,
            trading_address_landmark:
              apiResponse?.data?.data?.trading_address_landmark,
            trading_address_state:
              apiResponse?.data?.data?.trading_address_state,
            trading_address_city: apiResponse?.data?.data?.trading_address_city,
            trading_address_pincode:
              apiResponse?.data?.data?.trading_address_pincode_number,

            pincode: apiResponse.data.data.pincode_name,
            phone: String(apiResponse.data.data.phone),
            msme: apiResponse.data.data.msme,
            city: apiResponse.data.data.city_name,
            vendor_inquiry_value: apiResponse.data.data.inquiry_value.map(
              (inquiry) => {
                const { vendor, vendor_name, category_tree_name, ...rest } =
                  inquiry;
                return rest;
              }
            ),
            vendor_code_by_company:
              apiResponse.data.data.vendor_company_code[0]
                .vendor_code_by_company,

            // assign_city_to_vendor: apiResponse.data.data.assign_city.map(
            //   (inquiry) => {
            //     const {
            //       // id,
            //       vendor,
            //       vendor_name,
            //       city_name,
            //       company_name,
            //       material_type_name,
            //       ...rest
            //     } = inquiry;

            //     return rest;
            //   }
            // ),
          });

          const url = apiResponse.data.data.vendor_logo;
          setIdentifyProfileUrl(apiResponse.data.data.vendor_logo);
          if (url !== null) {
            setFileList([
              {
                url: url,
              },
            ]);
          }
          setSelectedOption(apiResponse.data.data.msme);
          const modifiedInquiry = apiResponse.data.data.inquiry_value.map(
            (inquiryDetail) => {
              const { id, vendor, vendor_name, ...rest } = inquiryDetail;
              return rest;
            }
          );
          setWeightSizeInquiryFieldValue(modifiedInquiry);

          const modifiedInquiryCity = apiResponse.data.data.assign_city.map(
            (inquiryDetail) => {
              const { id, vendor, vendor_name, ...rest } = inquiryDetail;
              return rest;
            }
          );
          setWeightSizeInquiryFieldValueCity(modifiedInquiryCity);

          const modifiedInquirySuppliers =
            apiResponse.data.data.suppliers_billing_details.map(
              (inquiryDetail) => {
                const { id, vendor, vendor_name, ...rest } = inquiryDetail;
                return rest;
              }
            );
          setWeightSizeInquiryFieldValueSuppliers(modifiedInquirySuppliers);

          if (apiResponse?.data?.data?.email_verified === true) {
            setVerificationResultEmail("success");
            setVerifyEmailButtonView(false);
          } else {
            setVerificationResultEmail(null);
            setVerifyEmailButtonView(true);
          }

          if (apiResponse?.data?.data?.phone_verified === true) {
            setVerificationResultContact("success");
            setVerifyPhoneButtonView(false);
          } else {
            setVerificationResultContact(null);
            setVerifyPhoneButtonView(true);
          }

          if (apiResponse?.data?.data?.gst_no_verified === true) {
            setVerificationStatus("success");
            setVerifyGstButtonView(false);
          } else {
            setVerificationStatus(null);
            setVerifyGstButtonView(true);
          }

          if (apiResponse?.data?.data?.udyam_aadhaar_no_verified === true) {
            setVerificationResultAadhaar("success");
            setVerifyAdhaarButtonView(false);
          } else {
            setVerificationResultAadhaar(null);
            setVerifyAdhaarButtonView(true);
          }
          // setShowAssignSiteCollapse(true);
          // setShowBankDetailsCollapse(true);

          // setShowVendorCommunicationCollapse(true);
          if (
            apiResponse.data.data?.registered_business_address_building ===
              apiResponse.data.data?.trading_address_building &&
            apiResponse.data.data?.registered_business_address_area ===
              apiResponse.data.data?.trading_address_area &&
            apiResponse.data.data?.registered_business_address_landmark ===
              apiResponse.data.data?.trading_address_landmark &&
            apiResponse.data.data?.registered_business_address_state ===
              apiResponse.data.data?.trading_address_state &&
            // apiResponse.data.data?.registered_business_address_city ===
            //   apiResponse.data.data?.registered_business_address_city &&
            apiResponse.data.data?.registered_business_address_pincode ===
              apiResponse.data.data?.trading_address_pincode
          ) {
            setSameAsRegisteredBusinessAddress(true);
          }
        } else {
          ErrorNotificationMsg(t("error_in_list_delivery_address"));
          setSameAsRegisteredBusinessAddress(false);
        }
        setFormSubmitted(true);

        setapiloading(false);
      } catch (error) {
        setapiloading(false);
      }
    };
    getVendorOnboarding();
    getCategoryTree();
    getMaterialTypeByCategory();
    getMatrixSteps();
    getCompanyList();
  }, [VendorId, CompanyId, t, vendorId]);
  useEffect(() => {
    const getEditVendorCommunicationMatrix = async () => {
      setapiloading(true);
      try {
        let filenameone1;
        const apiResponse = await getRequest(
          "vendor-communication-matrix/" + vendorCommunicationId
        );

        if (apiResponse.data.success) {
          setDocumentState({
            ...apiResponse?.data?.data?.vendor_communication_matrix[0],
          });
          // setFileLinkOne(apiResponse.data.data.document_url);
          try {
            filenameone1 = apiResponse.data.data.document_url.split("/").pop();
            setFileNameOne(filenameone1);
          } catch (e) {
            filenameone1 = "";
            setFileNameOne(null);
          }
          formRef.current.setFieldsValue({
            ...apiResponse.data.data,
          });
        } else {
          ErrorNotificationMsg(t("err_getSubscription"));
        }
        setapiloading(false);
      } catch (error) {
        setapiloading(false);
      }
    };
    if (vendorCommunicationId !== null) {
      getEditVendorCommunicationMatrix();
    }
    getCompanyList();
  }, [vendorDocumentId, t]);
  const getCompanyList = async () => {
    setapiloading(true);
    try {
      const apiResponse = await getRequest("company/");
      if (apiResponse.data.results.success) {
        setCompanyList(apiResponse.data.results.data);
      } else {
        ErrorNotificationMsg(t("err_getConcierge"));
      }
      setapiloading(false);
    } catch (error) {
      setapiloading(false);
    }
  };
  const getMatrixSteps = async (data) => {
    await getRequest("vendor-matrix-steps/?no_pagination=True", data).then(
      (response) => {
        console.log("VendorMatrixStep", response);
        setVendorMatrixSteps(response.data?.data);
      }
    );
  };
  const [pincodeListBilling, setPincodeListBilling] = useState([]);
  const searchINBilling = async (value) => {
    const apiResponse = await getRequest(
      `pincode/?search_pincode_number=${value}`
    );
    if (apiResponse.data.results.success) {
      setPincodeListBilling(apiResponse.data.results.data);
    }
  };
  const onSearchBilling = async (value) => {
    setSearchValueBilling(value);
    value.length >= 4
      ? searchINBilling(!value ? null : value)
      : setPincodeListBilling([]);
  };
  // const handleDeleteRecord = async (id = []) => {
  //   let ids = selectedRow;
  //   if (ids.length === 0) {
  //     ids.push(id);
  //   }
  //   try {
  //     let apiResponse = await deleteRequest(
  //       `vendor-communication-matrix/${ids}`,
  //       {
  //         deleted: ids,
  //       }
  //     );
  //     if (apiResponse.data.success) {
  //       SuccessNotificationMsg(t("Deleted Successfully"));
  //       setReload(!reload);
  //       setSelectedRow([]);
  //     } else {
  //       ErrorNotificationMsg(t("Error In Delete"));
  //     }
  //   } catch (error) {
  //     console.log("");
  //   }
  // };

  const handleDeleteRecord = async (id = []) => {
    console.log();

    let ids = selectedRow; // Assuming selectedRow is coming from state
    if (ids.length === 0) {
      ids.push(id); // Add single id to the array if no selection exists
    }

    try {
      const apiResponse = await deleteRequest(
        `vendor-communication-matrix/${ids}`
        // {
        //   deleted: ids,
        // }
      );

      if (apiResponse.data.success) {
        SuccessNotificationMsg("Deleted Successfully");
        setReload(!reload); // Trigger table reload
        setSelectedRow([]); // Clear selected rows
      } else {
        ErrorNotificationMsg("Error In Delete");
      }
    } catch (error) {
      console.error("Error deleting record:", error);
      // ErrorNotificationMsg("An error occurred while deleting the record");
    }
  };

  const handleSendOtpEmail = async () => {
    try {
      const payload = {
        email: state?.email ? state.email : "",
      };
      const response = await postRequest(`verified-otp/email-verify/`, payload);
      if (response.data.success) {
        const errorMessage = response?.data?.message || "";

        const emailVerificationRegex = /This [^ ]+ already Verify/;
        if (emailVerificationRegex.test(errorMessage)) {
          setVerifyEmailButtonView(false);

          setState((prevState) => ({
            ...prevState,
            email_verified: true,
          }));
          setVerificationResultEmail("success");
        } else {
          setState((prevState) => ({
            ...prevState,
            email_verified: false,
          }));
          showModal();
          setVerifyEmailButtonView(true);
        }
        SuccessNotificationMsg(response.data.message);
      } else {
        handleCancel();
        setVerificationResultEmail("");
      }
    } catch (error) {
      handleCancel();
      setVerifyEmailButtonView(true);
      setVerificationResultEmail("");
    }
  };
  const handleSendOtpPhone = async () => {
    try {
      const payload = {
        phone_number: state?.phone ? state.phone : "",
      };
      const response = await postRequest(
        `verified-otp/phone-number-verify/`,
        payload
      );
      if (response.data.success) {
        const errorMessage = response?.data?.message || "";
        const emailVerificationRegex = /This [^ ]+ already Verify/;

        if (emailVerificationRegex.test(errorMessage)) {
          setVerifyPhoneButtonView(false);

          setState((prevState) => ({
            ...prevState,
            phone_verified: true,
          }));
          setVerificationResultContact("success");
        } else {
          setState((prevState) => ({
            ...prevState,
            phone_verified: false,
          }));
          showModalPhone();
          setVerifyPhoneButtonView(true);
        }
        SuccessNotificationMsg(response.data.message);
      } else {
        setVerificationResultContact("");
        handleCancelPhone();
        setVerifyPhoneButtonView(true);
      }
    } catch (error) {
      setVerifyPhoneButtonView(true);
      handleCancelPhone();
      setVerificationResultContact("");
    }
  };

  const handleStateChangeRegistered = (values) => {
    setState({
      ...state,
      registered_business_address_state: values,
      registered_business_address_city: null,
    });
    setCityDropdownOptions([]);
    formRef.current.setFieldsValue({
      ...state,
      registered_business_address_state: values,
      registered_business_address_city: "",
      registered_business_address_pincode:
        state?.registered_business_address_pincode_number,
      trading_address_pincode: state.trading_address_pincode_number,
    });
  };

  const handleStateChangeTrading = (values) => {
    setState({
      ...state,
      trading_address_state: values,
      trading_address_city: null,
    });
    setTradingCityDropdownOptions([]);
    formRef.current.setFieldsValue({
      ...state,
      trading_address_state: values,
      trading_address_city: "",
      trading_address_pincode: state.trading_address_pincode_number,
      registered_business_address_pincode:
        state?.registered_business_address_pincode_number,
    });
  };
  // Table Vendor Communication Matrix
  useEffect(() => {
    const getVendorCommunicationList = async () => {
      setLoading(true);
      try {
        let apiResponse = await getRequest(
          `vendor-communication-matrix/${vendorLoginId}/get-vendor-communication-matrix/`,
          stateTable
        );
        if (apiResponse.data.results.success === true) {
          setVendorCommunicationList(apiResponse?.data?.results?.data);
          settotalCount(apiResponse.data.count);
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    if (vendorLoginId !== null) {
      getVendorCommunicationList();
    }
  }, [stateTable, reload, t, refreshGrid, vendorLoginId]);

  useEffect(() => {
    const getVendorDocument = async () => {
      setapiloading(true);
      try {
        let filenameone1;
        const apiResponse = await getRequest(
          "vendor-document/" + vendorDocumentId
        );

        if (apiResponse.data.success) {
          setDocumentState({
            ...apiResponse.data.data,
          });
          try {
            filenameone1 = apiResponse.data.data.document_url.split("/").pop();
            setFileNameOne(filenameone1);
          } catch (e) {
            filenameone1 = "";
            setFileNameOne(null);
          }
          formRef.current.setFieldsValue({
            ...apiResponse.data.data,
          });
        } else {
          ErrorNotificationMsg(t("err_getSubscription"));
        }
        setapiloading(false);
      } catch (error) {
        setapiloading(false);
      }
    };
    if (vendorDocumentId !== null) {
      getVendorDocument();
    }
  }, [vendorDocumentId, t]);

  const getCategoryTree = async (data) => {
    await getRequest("category-tree/?no_pagination=True", data).then(
      (response) => {
        setCategoryTree(response.data.data);
        setCategoryTreeCity(response.data.data);
      }
    );
  };

  const getMaterialTypeByCategory = async (categoryId) => {
    try {
      const materialTypeResponse = await getRequest(
        `material-type/?category_tree_id=${1}`
      );

      setMaterialType(materialTypeResponse.data.results.data);
    } catch (error) {
      setLoading(false);
    }
  };
  const getGSTNumberVerify = useCallback(
    debounce(async (value, onTypeGst) => {
      onTypeGst(value);

      try {
        if (value !== "" && VendorId === null) {
          setapiloading(true);
          setGstValue(value);
          const apiResponse = await getRequest(
            `get-vendor-by-gst/?gst_no=${value}`
          );

          if (apiResponse.data.results.data.length > 0) {
            console.log("GST number is valid.");
          } else {
            console.log("GST number is not valid or no vendor found.");
          }

          setapiloading(false);
        }
      } catch (error) {
        setapiloading(false);
      }
    }, 1200),
    []
  );

  const phoneValidLength = state.phone;

  const validatePhoneNumber = () => {
    if (
      (phoneValidLength && phoneValidLength.length < 12) ||
      phoneValidLength === null ||
      phoneValidLength === ""
    ) {
      return Promise.reject(new Error(t("please_enter_valid_phone")));
    }

    return Promise.resolve();
  };

  const handleCategoryChange = (field, value, index) => {
    let newFeatureArr = state.assign_city_to_vendor;
    const newValue = value === undefined ? null : value;
    if (newFeatureArr[index]) {
      newFeatureArr[index][field] = newValue;
      setState({ ...state, assign_city_to_vendor: newFeatureArr });
    }
  };
  const handleStateChange = (field, index, value) => {
    let updatedAssignCity = [...state.assign_city_to_vendor];
    updatedAssignCity[index].state = value;
    updatedAssignCity[index].city = null;
    setState({ ...state, assign_city_to_vendor: updatedAssignCity });
  };

  const handleMaterialChange = (index, value) => {
    const updatedAssignCity = [...state.assign_city_to_vendor];
    updatedAssignCity[index].material_type = value;
    setState({ ...state, assign_city_to_vendor: updatedAssignCity });
  };

  const handleMaterialChangeForInquiry = (index, value) => {
    const updatedAssignCity = [...state.vendor_inquiry_value];
    updatedAssignCity[index].material_type = value;
    setState({ ...state, vendor_inquiry_value: updatedAssignCity });
  };

  const handleCityChangeSite = (field, index, value) => {
    const updatedAssignCity = [...state.assign_city_to_vendor];
    updatedAssignCity[index].city = value;
    setState({ ...state, assign_city_to_vendor: updatedAssignCity });
  };

  const handleGstInputChangeCity = (index, value) => {
    const updatedAssignCity = [...state.assign_city_to_vendor];
    updatedAssignCity[index].gst_number = value;
    setState({ ...state, assign_city_to_vendor: updatedAssignCity });
  };

  const handleInputChange = (e) => {
    let { name, value } = e.target;
    setState({ ...state, [name]: value !== "" ? value : null });
  };
  const handleInputChangeVendorCommunication = (e) => {
    let { name, value } = e.target;
    setVendorCommunicationState({
      ...vendorCommunicationState,
      [name]: value !== "" ? value : null,
    });
  };
  const handleInputChangePancard = (e) => {
    let { name, value } = e.target;
    setState({ ...state, [name]: value !== "" ? value : null });
    setVerificationResultPancard("");
  };
  const handleInputChangeVendorCode = (e) => {
    let { name, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      vendor_company_code: {
        ...prevState.vendor_company_code,
        vendor_code_by_company: value !== "" ? value : null,
      },
    }));
  };
  const handleInputChangeEmail = (e) => {
    let { name, value } = e.target;
    setVerifyEmailButtonView(true);
    setVerificationResultEmail("");
    setState((prevState) => ({
      ...prevState,
      email: value !== "" ? value : null,
      email_verified: false,
    }));
  };
  let flag = false;

  const debouncedFetchData = useCallback(
    debounce(async (value, onTypeGst) => {
      onTypeGst(value);

      try {
        if (value !== "" && VendorId === null) {
          setapiloading(true);
          setGstValue(value);
          const apiResponse = await getRequest(
            `get-vendor-by-gst/?gst_no=${value}`
          );

          if (!flag) {
            if (apiResponse.data.results.data.length > 0) {
              const {
                pincode_name,
                unique_code,
                id,
                company_payment_terms,
                keypersons,
                bankdetails,
                assgin_city,
                inquiry_value,
                vendor_company_code_data,
                ...filteredResponse
              } = apiResponse.data.results.data[0];

              setapiloading(false);
              setgstVendorId(apiResponse.data.results.data[0].id);
              setPostGeneratedVendorId(null);

              if (
                apiResponse.data.results.data[0].trading_address_state !==
                  null &&
                apiResponse.data.results.data[0].trading_address_state !==
                  undefined &&
                apiResponse.data.results.data[0].trading_address_state !== ""
              ) {
                // getCityByStateTrading(
                //   apiResponse.data.results.data[0].trading_address_state
                // );
              }
              if (
                apiResponse.data.results.data[0]
                  .registered_business_address_state !== null &&
                apiResponse.data.results.data[0]
                  .registered_business_address_state !== undefined &&
                apiResponse.data.results.data[0]
                  .registered_business_address_state !== ""
              )
                setState({
                  ...filteredResponse,
                  vendor_inquiry_value:
                    apiResponse.data.results.data[0].inquiry_value.map(
                      (inquiryDetail) => {
                        const {
                          id,
                          vendor,
                          vendor_name,
                          category_tree_name,
                          company_name,
                          company,
                          city_name,
                          ...rest
                        } = inquiryDetail;
                        return {
                          company: CompanyId,
                          ...rest,
                        };
                      }
                    ),
                  vendor_company_code: {
                    id: apiResponse.data.results.data[0]
                      .vendor_company_code_data[0].id,
                    company: CompanyId,
                    vendor_code_by_company:
                      apiResponse.data.results.data[0]
                        .vendor_company_code_data[0].vendor_code_by_company,
                  },
                  // assign_city_to_vendor:
                  //   apiResponse?.data?.results?.data[0]?.assign_city?.map(
                  //     (inquiryDetail) => {
                  //       const {
                  //         id,
                  //         vendor,
                  //         vendor_name,
                  //         city_name,
                  //         city,
                  //         company_name,
                  //         material_type_name,
                  //         ...rest
                  //       } = inquiryDetail;
                  //       return {
                  //         company: CompanyId,
                  //         ...rest,
                  //       };
                  //     }
                  //   ),
                });
              setFileLink(apiResponse.data.results.data[0].msme_document);
              const url = apiResponse.data.results.data[0].vendor_logo;
              setIdentifyProfileUrl(
                apiResponse.data.results.data[0].vendor_logo
              );
              if (url !== null) {
                setFileList([
                  {
                    url: url,
                  },
                ]);
              }
              setShowKeyPersonCollapse(true);
              const newItem =
                apiResponse.data.results.data[0].inquiry_value.map((item) => {
                  return item.category_tree;
                });
              setDisabledOptions(newItem);
              formRef.current.setFieldsValue({
                ...apiResponse.data.results.data[0],
                pincode: apiResponse.data.results.data[0].pincode_name,
                phone: String(apiResponse.data.results.data[0].phone),
                msme: apiResponse.data.results.data[0].msme,
                registered_business_address_pincode:
                  apiResponse.data.results.data[0]
                    ?.registered_business_address_pincode_number,
                trading_address_pincode:
                  apiResponse.data.results.data[0]
                    .trading_address_pincode_number,
              });
              if (
                apiResponse.data.results.data[0]
                  .registered_business_address_building ===
                  apiResponse.data.results.data[0]?.trading_address_building &&
                apiResponse.data.results.data[0]
                  ?.registered_business_address_area ===
                  apiResponse.data.results.data[0]?.trading_address_area &&
                apiResponse.data.results.data[0]
                  ?.registered_business_address_landmark ===
                  apiResponse.data.results.data[0]?.trading_address_landmark &&
                apiResponse.data.results.data[0]
                  ?.registered_business_address_state ===
                  apiResponse.data.results.data[0]?.trading_address_state &&
                apiResponse.data.results.data[0]
                  ?.registered_business_address_city ===
                  apiResponse.data.results.data[0]
                    ?.registered_business_address_city &&
                apiResponse.data.results.data[0]
                  ?.registered_business_address_pincode ===
                  apiResponse.data.results.data[0]?.trading_address_pincode
              ) {
                setSameAsRegisteredBusinessAddress(true);
              }
              setSelectedOption(apiResponse.data.results.data[0].msme);

              let modifiedInquiryDetails =
                apiResponse.data.results.data[0].inquiry_value.map(
                  (inquiry) => {
                    const { id, vendor, category_tree_name, ...rest } = inquiry;
                    return rest;
                  }
                );

              let modifiedAssignCityDetails =
                apiResponse.data.results.data[0].assign_city.map((inquiry) => {
                  const { id, vendor, category_tree_name, ...rest } = inquiry;
                  return rest;
                });
              setWeightSizeInquiryFieldValue(modifiedInquiryDetails);
              setWeightSizeAssignCityValue(modifiedAssignCityDetails);
              setShowKeyPersonCollapse(true);
              setShowVendorCommunicationCollapse(true);
              setShowBankDetailsCollapse(true);
              setShowVendorBillingDetails(true);
              setShowAssignSiteCollapse(true);
              setShowPaymentCollapse(true);
              setShowPaymentPersonReleasedField(true);
            } else {
              setgstVendorId(null);
              setFormSubmitted(false);
              setapiloading(false);
              setShowKeyPersonCollapse(false);
              setShowVendorCommunicationCollapse(false);
              setShowAssignSiteCollapse(false);
              setShowVendorBillingDetails(false);
              setShowBankDetailsCollapse(false);
              setShowPaymentCollapse(false);
              setShowPaymentPersonReleasedField(false);
              const newState = {
                ...initialState,
                gst_no: value,
              };
              setState({ ...initialState, gst_no: value });
              setDisabledOptions([]);
              setFileLink(null);
              const defaultCountryCode = "+91";
              formRef.current.setFieldsValue({
                ...initialState,
                gst_no: value,
                phone: defaultCountryCode,
              });
              state.vendor_inquiry_value.forEach((person, index) => {
                formRef.current.setFieldsValue({
                  [`category_tree${index}`]: "Cement",
                  [`minimum_inquiry_value${index}`]: null,
                  [`minimum_income_measurement${index}`]: "Lakh",
                  [`maximum_inquiry_value${index}`]: null,
                  [`maximum_income_measurement${index}`]: "Lakh",
                });
              });
              formRef.current.setFieldsValue({
                [`company`]: CompanyId,
                [`vendor_code_by_company`]: null,
                [`id`]: null,
              });

              const url = null;
              setIdentifyProfileUrl("");
            }
          } else {
            ErrorNotificationMsg(t("Vendor Already Exist"));
            setapiloading(false);
          }
        }
      } catch (error) {
        setapiloading(false);
      }
    }, 1200),
    []
  );
  useEffect(() => {
    return () => {
      debouncedFetchData.cancel();
    };
  }, [debouncedFetchData]);

  const gstPattern =
    /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
  const handleGstInputChange = async (e) => {
    let { name, value } = e.target;
    setVerifyGstButtonView(true);

    setState({ ...state, gst_no: value, gst_no_verified: false });
    setVerificationStatus(null);
    setVerifyDisable(!gstPattern.test(value));
  };

  const onTypeGst = (value) => {
    setState({
      ...state,
      gst_no: value,
    });
  };

  const handleSelectChange = (name, value) => {
    setState({ ...state, [name]: value });
  };

  const handleOptionChange = (name, value) => {
    if (value === false) {
      setState({ ...state, [name]: value, msme_number: null });
      setSelectedOption(false);
      formRef.current.setFieldsValue({
        msme_number: "",
      });
      setState((prevState) => ({
        ...prevState,
        msme_document: null,
      }));
      setUploadFile("");
      setFileName(null);
      setFileLink(null);
      setSize(null);
    } else {
      setState({ ...state, [name]: value });
      setSelectedOption(value);
    }
  };
  const handleChange = (name, value) => {
    setState({ ...state, [name]: value });
  };

  const handlePincodeChange = (name, value) => {
    const selectedOption = pincodeList.find(
      (option) => option.pincode_number === value
    );
    const selectedId = selectedOption ? selectedOption.id : null;
    setState({ ...state, [name]: selectedId });
  };
  const searchIN = async (value) => {
    const apiResponse = await getRequest(
      `pincode/?search_pincode_number=${value}`
    );

    if (apiResponse.data.results.success) {
      setPincodeList(apiResponse.data.results.data);
    }
  };
  const onSelect = (data) => {
    setSearchValue(!data ? "" : data);
  };

  const searchINBillingRegistered = async (value) => {
    const apiResponse = await getRequest(
      `pincode/?search_pincode_number=${value}`
    );
    if (apiResponse.data.results.success) {
      setPincodeListBillingRegistered(apiResponse.data.results.data);
    }
  };
  const [searchValueBillingRegistered, setSearchValueBillingResgistered] =
    useState("");

  const onSearchBillingResgistered = async (value) => {
    setSearchValueBillingResgistered(value);
    value.length >= 4
      ? searchINBillingRegistered(!value ? null : value)
      : setPincodeListBillingRegistered([]);
  };
  const [searchValueShippingTrading, setSearchValueShippingTrading] =
    useState("");
  const [pincodeListShippingtrading, setPincodeListShippingTrading] = useState(
    []
  );
  const searchINShippingTrading = async (value) => {
    const apiResponse = await getRequest(
      `pincode/?search_pincode_number=${value}`
    );
    if (apiResponse.data.results.success) {
      setPincodeListShippingTrading(apiResponse.data.results.data);
    }
  };
  const onSearchShippingTrading = async (value) => {
    setSearchValueShippingTrading(value);
    value.length >= 4
      ? searchINShippingTrading(!value ? null : value)
      : setPincodeListShippingTrading([]);
  };
  const handlePincodeShippingTradingChange = async (
    trading_address_pincode
  ) => {
    try {
      const response = await getRequest(
        `pincode/?search_pincode_number=${trading_address_pincode}`
      );
      if (response.data.results.data.length > 0) {
        const { state_name, city_name, id } = response.data.results.data[0];
        setState((prevState) => ({
          ...prevState,
          trading_address_state: state_name,
          trading_address_city: city_name,
          trading_address_pincode: id,
        }));
        formRef.current.setFieldsValue({
          trading_address_state: state_name,
          trading_address_city: city_name,
        });
      }
    } catch (error) {
      setLoading(false);
    }
  };
  const onSelectBilling = (data) => {
    setSearchValueBilling(!data ? "" : data);
  };
  const onSearch = async (value) => {
    setSearchValue(value);
    value.length >= 4 ? searchIN(!value ? null : value) : setPincodeList([]);
  };
  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      setErrorMsg("You can only upload JPG/PNG file!");
      message.error("You can only upload JPG/PNG file!");
      return Upload.LIST_IGNORE;
    }
    setErrorMsg("");
    return false;
  };

  const uploadProps = {
    accept: ".jpg, .png, .jpeg",
    showUploadList: false,
    beforeUpload: (file, name) => {
      setUploadFile(file);
      setFileName(file.name);

      return false;
    },
  };

  const uploadPropsOne = {
    accept: ".jpg, .png, .jpeg",
    showUploadList: false,
    beforeUpload: (file, name) => {
      setUploadFileOne(file);
      setFileNameOne(file.name);
      return false;
    },
  };

  const handleDelete = (name) => {
    if (name === "msme_document") {
      setState((prevState) => ({
        ...prevState,
        msme_document: null,
      }));
      setUploadFile("");
      setFileName(null);
      setFileLink(null);
      setSize(null);
    } else if (name === "document_url") {
      setState((prevState) => ({
        ...prevState,
        document_url: null,
      }));
      setUploadFileOne("");
      setFileNameOne(null);
      setFileLinkOne(null);
      setSizeOne(null);
    }
  };

  const handleFileDelete = async (name) => {
    const apiResponse = await deleteRequest(
      `vendor/${VendorId}/msme-document-delete/`
    );
    if (apiResponse.status) {
      if (name === "msme_d6 9ocument") {
        setFileName(null);
        setFileLink(null);
        setSize(null);
      } else if (name === "document_url") {
        setFileNameOne(null);
        setFileLinkOne(null);
        setSizeOne(null);
      }
    }
  };

  const handleRefreshGrid = () => {
    setRefreshGrid((refreshGrid) => !refreshGrid);
  };
  const handleClonePhoneInputChange = (field, phone, index) => {
    let newPersonArr = state.suppliers_billing_details;
    newPersonArr[index][field] = phone ? phone : null;
    setState({ ...state, suppliers_billing_details: newPersonArr });
  };
  const handlePancardNumberVerify = async () => {
    try {
      const pancard = state?.company_pan;

      const gstRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
      if (!pancard || !gstRegex.test(pancard)) {
        ErrorNotificationMsg(t("Invalid pancard number"));
        setVerificationResultPancard("error");
        return;
      }

      setBtnLoadingPan(true);
      const response = await getRequest(
        `pincode/?search_pincode_number=${pancard}`
      );
      if (response.data.results.data) {
        SuccessNotificationMsg("Pancard verified successfully");
        setVerificationResultPancard("success");
        setBtnLoadingPan(false);
      } else {
        ErrorNotificationMsg(t("Invalid pancard number"));
        setBtnLoadingPan(false);
        setVerificationResultPancard("error");
      }
    } catch (error) {
      ErrorNotificationMsg(t("Error in verifying pancard number"));
      setVerificationResultPancard("error");
      setBtnLoadingPan(false);
    }
  };
  const handleContactNumberVerify = async () => {
    const contactNumber = state?.phone;
    const phoneNumberPattern = /^\d{12}$/;

    if (contactNumber && phoneNumberPattern.test(contactNumber)) {
      await handleSendOtpPhone();
    } else {
      ErrorNotificationMsg("Enter valid mobile number");
    }
  };

  const handleEmailVerify = async () => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isEmailValid = emailPattern.test(state.email);
    if (isEmailValid) {
      await handleSendOtpEmail();
    } else {
      setVerifyEmailButtonView(true);
      ErrorNotificationMsg("Enter valid email");
    }
  };
  const handlePhoneInputVendorCommunication = (phone) => {
    setVendorCommunicationState((prevState) => ({
      ...prevState,
      phone_number: phone,
    }));
  };
  const handlePhoneInputChange = (phone) => {
    setVerifyPhoneButtonView(true);
    setState((prevState) => ({
      ...prevState,
      phone: phone,
      phone_verified: false,
    }));
    setVerificationResultContact("");
  };

  const handleSubmit = async () => {
    const payload = {
      vendor_registered_name: state.vendor_registered_name,
      person_name: state.person_name,
      designation: state.designation,
      email_verified: state.email_verified,
      phone_verified: state.phone_verified,
      gst_no_verified: state.gst_no_verified,
      udyam_aadhaar_no_verified: state.udyam_aadhaar_no_verified,
      gst_no: state.gst_no,
      udyam_aadhaar_no: state.udyam_aadhaar_no,
      email: state.email,
      phone: state.phone,
      vendor_trade_name: state.vendor_trade_name,
      registered_business_address_building:
        state.registered_business_address_building,
      registered_business_address_area: state.registered_business_address_area,
      registered_business_address_landmark:
        state.registered_business_address_landmark,
      registered_business_address_state:
        state.registered_business_address_state,
      registered_business_address_city: state.registered_business_address_city,
      registered_business_address_pincode:
        state.registered_business_address_pincode,
      trading_address_building: state.trading_address_building,
      trading_address_area: state.trading_address_area,
      trading_address_landmark: state.trading_address_landmark,
      trading_address_state: state.trading_address_state,
      trading_address_city: state.trading_address_city,
      trading_address_pincode: state.trading_address_pincode,
    };

    try {
      setBtnLoading(true);
      let apiResponse;
      let customerHeaders = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      const formData = new FormData();

      formData.append("vendor_logo", uploadFileProfilePic);
      formData.append("msme_document", uploadFile);
      formData.append("form_data", JSON.stringify(payload));
      if (VendorId !== null && gstVendorId !== null) {
        apiResponse = await postRequest("vendor/", formData, customerHeaders);
      }
      if (vendorId === null || gstVendorId === null) {
        const url =
          VendorId === null ? `vendor/${vendorId}/` : `vendor/${gstVendorId}/`;

        apiResponse = await patchRequest(url, formData, customerHeaders);
      }

      if (apiResponse.data.success === true) {
        setIsGstNoReadOnly(true);
        setPostGeneratedVendorId(apiResponse.data.data.id);
        if (apiResponse.data.data.keypersons.length > 0) {
          const keyPersonId =
            apiResponse.data.data.keypersons[0].id !== null
              ? apiResponse.data.data.keypersons[0].id
              : null;

          setKeyPersonId(keyPersonId);
        } else {
          setKeyPersonId(null);
        }
        const bankDetailId =
          apiResponse.data.data.bankdetails[0].id !== null
            ? apiResponse.data.data.bankdetails[0].id
            : null;
        setBankDetailId(bankDetailId);

        const supplierBillingId =
          apiResponse.data.data.suppliers_billing_details[0].id !== null
            ? apiResponse.data.data.suppliers_billing_details[0].id
            : null;
        SetSupplierBillingId(supplierBillingId);

        const paymentTermsId =
          apiResponse.data.data.company_payment_terms[0].id !== null
            ? apiResponse.data.data.company_payment_terms[0].id
            : null;
        setPaymentTermsId(paymentTermsId);

        if (gstVendorId) {
          const matchingPayment =
            apiResponse.data.data.company_payment_terms.find(
              (payment) => payment.company === CompanyId
            );

          const selectedId = matchingPayment ? matchingPayment.id : null;

          setAddedVendorId(selectedId);
        } else {
          setAddedVendorId(
            apiResponse.data.data.company_payment_terms.length > 0
              ? apiResponse.data.data.company_payment_terms[0].id
              : null
          );
        }

        setFormSubmitted(true);
        SuccessNotificationMsg(t("vendor_updated_successfully"));
      }
      setBtnLoading(false);
      setShowKeyPersonCollapse(true);
    } catch (error) {
      setBtnLoading(false);
      setIsGstNoReadOnly(false);
    }
  };

  const handleCloneCategorySelectChange = (field, value, index) => {
    let newFeatureArr = state.vendor_inquiry_value;
    const newValue = value === undefined ? null : value;
    if (newFeatureArr[index]) {
      newFeatureArr[index][field] = newValue;
      setState({ ...state, vendor_inquiry_value: newFeatureArr });
    }
  };

  const handlePincodeBillingChange = async (
    registered_business_address_pincode
  ) => {
    if (
      registered_business_address_pincode.length > 4 &&
      registered_business_address_pincode !== null &&
      registered_business_address_pincode !== "" &&
      registered_business_address_pincode !== undefined
    ) {
      try {
        const response = await getRequest(
          `pincode/?search_pincode_number=${registered_business_address_pincode}`
        );
        if (response.data.results.data.length > 0) {
          const { state_name, city_name, id, pincode_number } =
            response.data.results.data[0];
          setState((prevState) => ({
            ...prevState,
            registered_business_address_state: state_name,
            registered_business_address_city: city_name,
            registered_business_address_pincode: id,
            registered_business_address_pincode_number: pincode_number,
          }));
          formRef.current.setFieldsValue({
            registered_business_address_state: state_name,
            registered_business_address_city: city_name,
          });
        }
        // setApiLoading(false);
      } catch (error) {
        // setApiLoading(false);
        console.error("Error fetching state and city:", error);
      }
    } else {
      setState((prevState) => ({
        ...prevState,
        registered_business_address_state: "",
        registered_business_address_city: "",
        registered_business_address_pincode: "",
        registered_business_address_pincode_number: "",
      }));
      formRef.current.setFieldsValue({
        registered_business_address_state: "",
        registered_business_address_city: "",
      });
    }
  };
  const handlePincodeListingChange = async (index, pincode) => {
    try {
      const response = await getRequest(
        `pincode/?search_pincode_number=${pincode}`
      );
      if (response.data.results.data.length > 0) {
        const { state_name, city_name, id, pincode_number } =
          response.data.results.data[0];
        const updatedAssignCity = [...state.suppliers_billing_details];
        updatedAssignCity[index].pincode = id;
        updatedAssignCity[index].state = state_name;
        updatedAssignCity[index].city = city_name;
        setState({ ...state, suppliers_billing_details: updatedAssignCity });
        formRef.current.setFieldsValue({
          [`state_${index}`]: state_name,
          [`city_${index}`]: city_name,
        });
      }
    } catch (error) {
      console.error("Error fetching state and city:", error);
    }
  };
  const searchINShipping = async (value) => {
    const apiResponse = await getRequest(
      `pincode/?search_pincode_number=${value}`
    );
    if (apiResponse.data.results.success) {
      setPincodeListShipping(apiResponse.data.results.data);
    }
  };
  const onSelectShipping = (data) => {
    setSearchValueShipping(!data ? "" : data);
  };
  const onSearchShipping = async (value) => {
    setSearchValueShipping(value);
    value.length >= 4
      ? searchINShipping(!value ? null : value)
      : setPincodeListShipping([]);
  };
  const handleCloneInquiryInputChange = (field, e, index) => {
    let newPersonArr = state.vendor_inquiry_value;
    newPersonArr[index][field] = e.target.value ? e.target.value : null;
    setState({ ...state, vendor_inquiry_value: newPersonArr });
  };
  const handleClonegstInputChange = (field, e, index) => {
    let newPersonArr = state.suppliers_billing_details;
    newPersonArr[index][field] = e.target.value ? e.target.value : null;
    setState({ ...state, suppliers_billing_details: newPersonArr });
  };
  const handleCloneShopChange = (field, e, index) => {
    let newPersonArr = state.suppliers_billing_details;
    newPersonArr[index][field] = e.target.value ? e.target.value : null;
    setState({ ...state, suppliers_billing_details: newPersonArr });
  };
  const handleCloneAreaChange = (field, e, index) => {
    let newPersonArr = state.suppliers_billing_details;
    newPersonArr[index][field] = e.target.value ? e.target.value : null;
    setState({ ...state, suppliers_billing_details: newPersonArr });
  };
  const setWeightSizeInquiryFieldValue = (data) => {
    let stateArr = [];
    let fieldObject = {};

    data.map((objectValue, objectKey) => {
      stateArr.push(objectValue);
      fieldObject["company_material_type" + objectKey] =
        objectValue.company_material_type;
      fieldObject["minimum_inquiry_value" + objectKey] =
        objectValue.minimum_inquiry_value;
      fieldObject["maximum_inquiry_value" + objectKey] =
        objectValue.maximum_inquiry_value;

      return null;
    });
    formRef.current.setFieldsValue(fieldObject);
  };

  const setWeightSizeAssignCityValue = (data) => {
    let stateArr = [];
    let fieldObject = {};

    data.map((objectValue, objectKey) => {
      stateArr.push(objectValue);
      fieldObject["category_tree" + objectKey] = 1;
      fieldObject["material_type" + objectKey] = objectValue.material_type;
      fieldObject["state" + objectKey] = objectValue.state;
      fieldObject["city" + objectKey] = objectValue.city;
      fieldObject["gst_number" + objectKey] = objectValue.gst_number;
      return null;
    });
    formRef.current.setFieldsValue(fieldObject);
  };

  const addInquiry = () => {
    let newPersonArr = [
      ...state.vendor_inquiry_value,
      {
        company: CompanyId,
        category_tree: 1,
        minimum_inquiry_value: null,
        maximum_inquiry_value: null,
        material_type: null,
      },
    ];
    setState({ ...state, vendor_inquiry_value: newPersonArr });
    setWeightSizeInquiryFieldValue(newPersonArr);
  };

  const removeInquiry = async (lastIndex) => {
    let filterPersonArr = state.vendor_inquiry_value.filter(
      (item, index) => index !== lastIndex
    );
    setState({ ...state, vendor_inquiry_value: filterPersonArr });
    handleDisableOption(lastIndex, null);
    setWeightSizeInquiryFieldValue(filterPersonArr);
  };
  const handleCityChange = (values) => {
    setState({ ...state, registered_business_address_city: values });
  };

  const handleTradingCityChange = (values) => {
    setState({ ...state, trading_address_city: values });
  };

  const setWeightSizeInquiryFieldValueCity = (data) => {
    if (!Array.isArray(data)) {
      console.error("Data is not an array:", data);
      return;
    }

    let stateArr = [];
    let fieldObject = {};

    data.forEach((objectValue, objectKey) => {
      stateArr.push(objectValue);
      fieldObject[`category_tree${objectKey}`] = objectValue.category_tree;
      fieldObject[`material_type${objectKey}`] = objectValue.material_type;
      fieldObject[`city${objectKey}`] = objectValue.city_id;
    });
    if (formRef.current) {
      formRef.current.setFieldsValue(fieldObject);
    } else {
      console.error("formRef.current is not defined");
    }
  };
  const setWeightSizeInquiryFieldValueSuppliers = (data) => {
    if (!Array.isArray(data)) {
      console.error("Data is not an array:", data);
      return;
    }

    let stateArr = [];
    let fieldObject = {};

    data.forEach((objectValue, objectKey) => {
      stateArr.push(objectValue);
      fieldObject[`category_tree_${objectKey}`] = objectValue.category_tree;
      fieldObject[`gst_for_billing_${objectKey}`] = objectValue.gst_for_billing;
      fieldObject[`address_line_1_${objectKey}`] = objectValue.address_line_1;
      fieldObject[`address_line_2_${objectKey}`] = objectValue.address_line_2;
      fieldObject[`person_name_${objectKey}`] = objectValue.person_name;
      fieldObject[`landmark_${objectKey}`] = objectValue.landmark;
      fieldObject[`email_${objectKey}`] = objectValue.email;
      fieldObject[`mobile_number_${objectKey}`] = objectValue.mobile_number;
      fieldObject[`state_${objectKey}`] = objectValue.state;
      fieldObject[`city_${objectKey}`] = objectValue.city;
      fieldObject[`pincode_${objectKey}`] = objectValue.pincode;
    });

    if (formRef.current) {
      formRef.current.setFieldsValue(fieldObject);
    } else {
      console.error("formRef.current is not defined");
    }
  };
  const addInquiryCity = () => {
    const newCity = {
      company: CompanyId,
      category_tree: 1,
      material_type: null,
      city: null,
      state: null,
      gst_number: null,
    };
    setState({
      ...state,
      vendor_inquiry_value: [...state.assign_city_to_vendor, newCity],
    });
    setWeightSizeInquiryFieldValueCity(newCity);
  };
  const removeInquiryCity = (index) => {
    const updatedAssignCity = state.assign_city_to_vendor.filter(
      (_, i) => i !== index
    );
    setState({ ...state, assign_city_to_vendor: updatedAssignCity });
  };

  const handleDisableOptionCity = (index, value) => {
    const updatedDisabledOptions = [...disabledOptionsCity];
    if (value !== null) {
      updatedDisabledOptions[index] = value;
    } else {
      delete updatedDisabledOptions[index];
    }
    setDisabledOptionsCity(updatedDisabledOptions);
  };

  const handleDisableOption = (index, value) => {
    const updatedDisabledOptions = [...disabledOptions];
    if (value !== null) {
      updatedDisabledOptions[index] = value;
    } else {
      delete updatedDisabledOptions[index];
    }
    setDisabledOptions(updatedDisabledOptions);
  };
  const handleSameAsRegisteredBusinessAddressChange = (e) => {
    const checked = e.target.checked;
    setSameAsRegisteredBusinessAddress(checked);

    if (checked) {
      setState((prevState) => {
        return {
          ...prevState,
          same_as_registered_business_address: true,
          trading_address_building:
            prevState.registered_business_address_building,
          trading_address_area: prevState.registered_business_address_area,
          trading_address_landmark:
            prevState.registered_business_address_landmark,
          trading_address_state: prevState.registered_business_address_state,
          trading_address_city: prevState.registered_business_address_city,
          trading_address_pincode:
            prevState.registered_business_address_pincode,
          trading_address_pincode_number:
            prevState.registered_business_address_pincode_number,
        };
      });
      formRef.current.setFieldsValue({
        trading_address_building: state.registered_business_address_building,
        trading_address_area: state.registered_business_address_area,
        trading_address_landmark: state.registered_business_address_landmark,
        trading_address_state: state.registered_business_address_state,
        trading_address_city: state.registered_business_address_city,
        trading_address_pincode:
          state.registered_business_address_pincode_number,
      });

      if (
        state?.registered_business_address_state !== null &&
        state?.registered_business_address_state !== undefined &&
        state?.registered_business_address_state !== ""
      ) {
        ////getCityByStateTrading(state.registered_business_address_state);
      }
    } else {
      setState((prevState) => ({
        ...prevState,
        same_as_registered_business_address: false,
        trading_address_building: "",
        trading_address_area: "",
        trading_address_landmark: "",
        trading_address_state: "",
        trading_address_city: "",
        trading_address_pincode: "",
      }));

      formRef.current.setFieldsValue({
        trading_address_building: "",
        trading_address_area: "",
        trading_address_landmark: "",
        trading_address_state: "",
        trading_address_city: "",
        trading_address_pincode: "",
      });
    }
  };

  const items = [
    {
      key: "1",
      label: "This is panel header 1",
      children: (
        <KeyPersonVendor
          VendorId={postGeneratedVendorId}
          keypersonId={keyPersonId}
          setKeyPersonId={setKeyPersonId}
          gstVendorId={gstVendorId}
          gstValue={gstValue}
        />
      ),
    },
    {
      key: "2",
      label: "This is panel header 2",
      children: <p>{"B"}</p>,
    },
    {
      key: "3",
      label: "This is panel header 3",
      children: <p>{"C"}</p>,
    },
  ];

  return (
    <>
          <div className="ListingTopBar">
              <div className="pagenamewrap">
                <div className="pagename">
                  <h3>My Company</h3>
      
                  <Breadcrumb className="Breadcrumb-Sec">
                    <Breadcrumb.Item>
                      <Link to="/dashboard">{t("home")}</Link>
                    </Breadcrumb.Item>
      
                    <Breadcrumb.Item>My Company</Breadcrumb.Item>
                  </Breadcrumb>
                </div>
              </div>
            </div>
          
            <Content className="stepscontentwrap">
             
              <div className="stepsContent">
                <div className="formwrapper" style={{ paddingRight: "5px" }}>
                  <Form onFinish={handleSubmit} autoComplete="off" ref={formRef}>
                  <Collapse defaultActiveKey={["1"]} onChange={onChange}>
                    <Panel header="Business Info" key="1">
                      <Row gutter={16}>
                        <Col
                          xs={24}
                          sm={24}
                          md={6}
                          lg={4}
                          xl={4}
                          className="TextFeild gutter-row"
                        >
                          <InputField
                            name="gst_no"
                            label={t("place_gst_no5")}
                            placeholder={t("place_gst_no")}
                            rules={t("val_gst_no")}
                            pattern={
                              "^[0-9]{2}[A-Z]{5}[0-9]{4}" +
                              "[A-Z]{1}[1-9A-Z]{1}" +
                              "Z[0-9A-Z]{1}$"
                            }
                            disabled={true}
                            prefix={<IdcardOutlined />}
                            handleInputChange={handleGstInputChange}
                          />
                        </Col>
                        {verifyGstButtonView === true ? (
                          <ButtonField
                            type="primary"
                            label={t("Verify")}
                            className="SaveGradiantBtn verify"
                            loading={btnLoadingVerifyGst}
                            onClick={handleGstNumberVerify}
                            disabled={state?.gst_no ? verifyGstDisable : true}
                          />
                        ) : (
                          ""
                        )}

                        {verificationStatus === "success" && (
                          <img
                            src={verifybtn}
                            style={{ height: "36px", marginTop: "29px" }}
                          ></img>
                        )}
                        <Col
                          xs={24}
                          sm={24}
                          md={6}
                          lg={4}
                          xl={4}
                          className="TextFeild gutter-row"
                        >
                          <InputField
                            name="udyam_aadhaar_no"
                            label={t("Udyam Number")}
                            placeholder={t("Enter Udyam Number")}
                            // rules={t("Please enter valid udyam number")}
                            prefix={<IdcardOutlined />}
                            disabled={true}
                            handleInputChange={handleInputAdhaarChange}
                          />
                        </Col>
                        {verifyAdhaarButtonView === true ? (
                          <ButtonField
                            type="primary"
                            className="SaveGradiantBtn verify"
                            onClick={handleAdhaarNumberVerify}
                            label={t("Verify")}
                            loading={btnLoadingAdhaar}
                          />
                        ) : (
                          ""
                        )}

                        {verificationResultAdhaar === "success" && (
                          <img
                            src={verifybtn}
                            style={{ height: "36px", marginTop: "29px" }}
                          ></img>
                        )}
                        <Col xs={24} sm={24} md={12} xl={8} xxl={6}>
                          <div className="verifywrap">
                            <InputField
                              name="vendor_registered_name"
                              label={t("label_vendor_company_name")}
                              placeholder={t("pl_vendor_company_name")}
                              rules={t("val_vendor_company_name")}
                              prefix={<Vector />}
                              handleInputChange={handleInputChange}
                              max={30}
                            />
                          </div>
                        </Col>
                        <Col xs={24} sm={24} md={12} xl={8} xxl={6}>
                          <div className="verifywrap">
                            <InputField
                              placeholder="Enter vendor trade name"
                              name="vendor_trade_name"
                              label={t("Vendor Trade Name")}
                              rules={t("Please enter vendor trade name")}
                              prefix={<AddressLine />}
                              handleInputChange={handleInputChange}
                              max={50}
                            />
                          </div>
                        </Col>
                      </Row>
                      <div className="vendorsubtitle">Contact Information</div>
                      <Row gutter={16}>
                        <Col xs={24} sm={24} md={12} xl={8} xxl={6}>
                          <InputField
                            name="person_name"
                            label={t("label_person_name")}
                            placeholder={t("pl_person_name")}
                            rules={t("val_person_name")}
                            prefix={<Name />}
                            handleInputChange={handleInputChange}
                            max={30}
                            pattern="^[A-Za-z\s]+$"
                          />
                        </Col>
                        <Col xs={24} sm={24} md={12} xl={8} xxl={6}>
                          <InputField
                            name="designation"
                            label={t("label_designation")}
                            placeholder={t("pl_designation")}
                            rules={t("val_designation")}
                            prefix={<AddressLine />}
                            handleInputChange={handleInputChange}
                            max={30}
                          />
                        </Col>
                        <Col xs={24} sm={12} md={6} xl={8} xxl={6}>
                          <div className="verifywrap">
                            <EmailField
                              name="email"
                              label={t("label_email")}
                              placeholder={t("pl_email_2")}
                              rules={t("val_email")}
                              prefix={<Email />}
                              handleInputChange={handleInputChangeEmail}
                            />

                            {verifyEmailButtonView === true ? (
                              <ButtonField
                                type="primary"
                                className="SaveGradiantBtn verify"
                                onClick={handleEmailVerify}
                                label={t("Verify")}
                                loading={btnLoadingEmail}
                              />
                            ) : (
                              ""
                            )}

                            {verificationResultEmail === "success" && (
                              <img
                                src={verifybtn}
                                style={{ height: "36px", marginTop: "29px" }}
                              ></img>
                            )}
                          </div>
                        </Col>
                        <Col xs={24} sm={24} md={6} xl={6} xxl={6}>
                          <div className="verifywrap">
                            <Form.Item
                              name="phone"
                              label={t("label_mobileNumber")}
                              placeholder={t("pl_mobileNumber")}
                              rules={[
                                {
                                  required: true,
                                  validator: validatePhoneNumber,
                                  message: (
                                    <Trans> {t("val_mobileNumber")}</Trans>
                                  ),
                                },
                              ]}
                            >
                              <div className="verifywrap">
                                <div className="phonefield">
                                  <PhoneInput
                                    className="PhoneSection"
                                    country={"in"}
                                    value={state.phone}
                                    onChange={handlePhoneInputChange}
                                  />
                                </div>
                              </div>
                            </Form.Item>
                            {verifyPhoneButtonView === true ? (
                              <ButtonField
                                type="primary"
                                className="SaveGradiantBtn verify"
                                onClick={handleContactNumberVerify}
                                label={t("Verify")}
                                loading={btnLoadingPhone}
                              />
                            ) : (
                              ""
                            )}

                            {verificationResultContact === "success" && (
                              <img
                                src={verifybtn}
                                style={{ height: "36px", marginTop: "29px" }}
                              ></img>
                            )}
                          </div>
                        </Col>
                      </Row>
                      <Row gutter={32}>
                        <Col xs={24} xxl={12} className="bdr">
                          <div className="colwrap">
                            <div className="colsubtitle">
                              Registered Business Address
                            </div>
                            <Row gutter={16}>
                              <Col xs={24} md={12}>
                                <Form.Item
                                  name="registered_business_address_building"
                                  label={t("Shop No., Building, Apartment")}
                                  rules={[
                                    {
                                      required: true,
                                      message: t(
                                        "Please enter shop no., building, company, apartment"
                                      ),
                                    },
                                  ]}
                                >
                                  <Input
                                    placeholder={t(
                                      "Enter shop no., building, apartment"
                                    )}
                                    maxLength={50}
                                    value={
                                      state.registered_business_address_building
                                    }
                                    onChange={(e) =>
                                      handleChange(
                                        "registered_business_address_building",
                                        e.target.value
                                      )
                                    }
                                  />
                                </Form.Item>
                              </Col>
                              <Col xs={24} md={12}>
                                <Form.Item
                                  name="registered_business_address_area"
                                  label={t("Area, Street")}
                                  rules={[
                                    {
                                      required: true,
                                      message: t("Please enter Area, Street"),
                                    },
                                  ]}
                                >
                                  <Input
                                    placeholder={t("Enter area, street")}
                                    maxLength={50}
                                    value={
                                      state.registered_business_address_area
                                    }
                                    onChange={(e) =>
                                      handleChange(
                                        "registered_business_address_area",
                                        e.target.value
                                      )
                                    }
                                  />
                                </Form.Item>
                              </Col>
                              <Col xs={24} md={12}>
                                <Form.Item
                                  name="registered_business_address_landmark"
                                  label={t("Landmark")}
                                  rules={[
                                    {
                                      required: true,
                                      message: t("Please enter landmark"),
                                    },
                                  ]}
                                >
                                  <Input
                                    placeholder={t("Enter landmark")}
                                    maxLength={50}
                                    value={
                                      state.registered_business_address_landmark
                                    }
                                    onChange={(e) =>
                                      handleChange(
                                        "registered_business_address_landmark",
                                        e.target.value
                                      )
                                    }
                                  />
                                </Form.Item>
                              </Col>

                              <Col xs={24} md={12}>
                                <Form.Item
                                  name="registered_business_address_pincode"
                                  label={t("pl_pincode")}
                                  prefix={<ZipCode />}
                                  rules={[
                                    {
                                      required: true,
                                      message: (
                                        <Trans>
                                          {t("val_postal_zip_code")}
                                        </Trans>
                                      ),
                                    },
                                  ]}
                                >
                                  <AutoComplete
                                    className="autoComplete"
                                    onSearch={onSearchBillingResgistered}
                                    value={
                                      state.registered_business_address_pincode
                                    }
                                    optionFilterProp="children"
                                    allowClear
                                    placeholder={t("pl_pincodeselect")}
                                    onChange={handlePincodeBillingChange}
                                    onKeyPress={(e) => {
                                      if (!/^\d$/.test(e.key)) {
                                        e.preventDefault(); // blocks any non-numeric key
                                      }
                                    }}
                                  >
                                    {pincodeListBillingRegistered.map(
                                      (option) => (
                                        <Option
                                          key={option.id}
                                          value={option.pincode_number}
                                        >
                                          {option.pincode_number}
                                        </Option>
                                      )
                                    )}
                                  </AutoComplete>
                                </Form.Item>
                              </Col>
                              <Col xs={24} md={12}>
                                <Form.Item
                                  name="registered_business_address_city"
                                  label={t("pl_city")}
                                  rules={[
                                    {
                                      required: true,
                                      message: <Trans>{t("val_city")}</Trans>,
                                    },
                                  ]}
                                >
                                  <Input
                                    placeholder={t("place_city")}
                                    value={
                                      state.registered_business_address_city
                                    }
                                    disabled
                                  />
                                </Form.Item>
                              </Col>
                              <Col xs={24} md={12}>
                                <Form.Item
                                  name="registered_business_address_state"
                                  label={t("pl_state_province")}
                                  value={
                                    state.registered_business_address_state
                                  }
                                  rules={[
                                    {
                                      required: true,
                                      message: (
                                        <Trans>{t("val_state_province")}</Trans>
                                      ),
                                    },
                                  ]}
                                >
                                  <Input
                                    value={
                                      state.registered_business_address_state
                                    }
                                    placeholder={t("place_state")}
                                    disabled
                                  />
                                </Form.Item>
                              </Col>
                            </Row>
                          </div>
                        </Col>
                        <Col xs={24} xxl={12}>
                          <div className="colwrap">
                            <div className="colsubtitle">
                              Trading Address
                              <Tooltip
                                title="Same as registered business address"
                                name="same_as_registered_business_address"
                              >
                                <Checkbox
                                  style={{ marginLeft: "10px" }}
                                  checked={sameAsRegisteredBusinessAddress}
                                  onChange={(e) =>
                                    handleSameAsRegisteredBusinessAddressChange(
                                      e
                                    )
                                  }
                                >
                                  Same as my business address
                                </Checkbox>
                              </Tooltip>
                            </div>
                            <Row gutter={16}>
                              <Col xs={24} md={12}>
                                <Form.Item
                                  name="trading_address_building"
                                  label={t(
                                    "Shop No, Building, Company, Apartment"
                                  )}
                                  rules={[
                                    {
                                      required: true,
                                      message: t(
                                        "Please enter shop no., building, company, apartment"
                                      ),
                                    },
                                  ]}
                                >
                                  <Input
                                    placeholder={t(
                                      "Enter shop no., building, company, apartment"
                                    )}
                                    maxLength={50}
                                    value={state.trading_address_building}
                                    onChange={(e) =>
                                      handleChange(
                                        "trading_address_building",
                                        e.target.value
                                      )
                                    }
                                  />
                                </Form.Item>
                              </Col>
                              <Col xs={24} md={12}>
                                <Form.Item
                                  name="trading_address_area"
                                  label={t("Area, Street")}
                                  rules={[
                                    {
                                      required: true,
                                      message: t("Please enter Area, Street"),
                                    },
                                  ]}
                                >
                                  <Input
                                    placeholder={t("Enter area, street")}
                                    maxLength={50}
                                    value={state.trading_address_area}
                                    onChange={(e) =>
                                      handleChange(
                                        "trading_address_area",
                                        e.target.value
                                      )
                                    }
                                  />
                                </Form.Item>
                              </Col>
                              <Col xs={24} md={12}>
                                <Form.Item
                                  name="trading_address_landmark"
                                  label={t("Landmark")}
                                  rules={[
                                    {
                                      required: true,
                                      message: t("Please enter landmark"),
                                    },
                                  ]}
                                >
                                  <Input
                                    placeholder={t("Enter landmark")}
                                    maxLength={50}
                                    value={state.trading_address_landmark}
                                    onChange={(e) =>
                                      handleChange(
                                        "trading_address_landmark",
                                        e.target.value
                                      )
                                    }
                                  />
                                </Form.Item>
                              </Col>
                              <Col xs={24} md={12}>
                                <Form.Item
                                  name="trading_address_pincode"
                                  label={t("pl_pincode")}
                                  prefix={<ZipCode />}
                                  rules={[
                                    {
                                      required: true,
                                      message: (
                                        <Trans>
                                          {t("val_postal_zip_code")}
                                        </Trans>
                                      ),
                                    },
                                  ]}
                                >
                                  <AutoComplete
                                    className="autoComplete"
                                    onSearch={onSearchShippingTrading}
                                    value={state.trading_address_pincode}
                                    optionFilterProp="children"
                                    allowClear
                                    placeholder={t("pl_pincodeselect")}
                                    onChange={
                                      handlePincodeShippingTradingChange
                                    }
                                    onKeyPress={(e) => {
                                      if (!/^\d$/.test(e.key)) {
                                        e.preventDefault(); // blocks any non-numeric key
                                      }
                                    }}
                                  >
                                    {pincodeListShippingtrading.map(
                                      (option) => (
                                        <Option
                                          key={option.id}
                                          value={option.pincode_number}
                                        >
                                          {option.pincode_number}
                                        </Option>
                                      )
                                    )}
                                  </AutoComplete>
                                </Form.Item>
                              </Col>
                              <Col xs={24} md={12}>
                                <Form.Item
                                  name="trading_address_city"
                                  label={t("pl_city")}
                                  rules={[
                                    {
                                      required: true,
                                      message: <Trans>{t("val_city")}</Trans>,
                                    },
                                  ]}
                                >
                                  <Input
                                    placeholder={t("place_city")}
                                    value={state.trading_address_city}
                                    disabled
                                  />
                                </Form.Item>
                              </Col>

                              <Col xs={24} md={12}>
                                <Form.Item
                                  name="trading_address_state"
                                  label={t("pl_state_province")}
                                  value={state.trading_address_state}
                                  rules={[
                                    {
                                      required: true,
                                      message: (
                                        <Trans>{t("val_state_province")}</Trans>
                                      ),
                                    },
                                  ]}
                                >
                                  <Input
                                    placeholder={t("place_state")}
                                    value={state.trading_address_state}
                                    disabled
                                  />
                                </Form.Item>
                              </Col>
                            </Row>
                          </div>
                        </Col>
                      </Row>
                      <div className="subbuttonsrow">
                        <Button
                          cursor="pointer"
                          className="primary"
                          icon={<SaveOutlined />}
                          type="primary"
                          htmlType="submit"
                          label="Save"
                        >
                          Save
                        </Button>
                      </div>
                    </Panel>
                    <Collapse>
                      <Panel
                        header="Key Person"
                        key="7"
                        disabled={!showKeyPersonCollapse}
                      >
                        <KeyPersonVendor
                          VendorId={postGeneratedVendorId}
                          keypersonId={keyPersonId}
                          setKeyPersonId={setKeyPersonId}
                          gstVendorId={gstVendorId}
                          gstValue={gstValue}
                          // setShowBankDetailsCollapse={
                          //   setShowBankDetailsCollapse
                          // }
                          setShowVendorBillingDetails={
                            setShowVendorBillingDetails
                          }
                        />
                      </Panel>
                    </Collapse>
                    <Panel
                      header="Vendor Company Code As Per Company ERP System"
                      key="13"
                    >
                      <Table
                        columns={columns}
                        rowKey={(record) => record.id}
                        dataSource={companycode}
                        pagination={{
                          defaultCurrent: state.page,
                          defaultPageSize: state.pagesize,
                          showTotal: (total) => `Total ${total} items`,
                          showSizeChanger: true,
                        }}
                        onChange={handleTableChange}
                      />
                    </Panel>
                    <Panel header="Inquiry Value" key="14">
                      <Table
                        rowSelection={rowSelection}
                        columns={columnsInquiryValue}
                        rowKey={(record) => record.id}
                        dataSource={companyInquiryValue}
                        pagination={{
                          defaultCurrent: state.page,
                          defaultPageSize: state.pagesize,
                          total: totalCount,
                          showTotal: (total) => `Total ${total} items`,
                          showSizeChanger: true,
                        }}
                        onChange={handleTableChange}
                      />
                    </Panel>
                    {/* <Panel header="Assign City" key="15">
                      <Table
                        columns={columnsAssignCity}
                        rowKey={(record) => record.id}
                        dataSource={companyassigncity}
                        pagination={{
                          defaultCurrent: state.page,
                          defaultPageSize: state.pagesize,
                          showTotal: (total) => `Total ${total} items`,
                          showSizeChanger: true,
                        }}
                        onChange={handleTableChange}
                      />
                    </Panel> */}
                    <Panel
                      header="Vendor Billing Details"
                      key="3"
                      disabled={!showVendorBillingDetails}
                    >
                      <Table
                        columns={columnsSupplierBillingDetails}
                        dataSource={companysupplierbillingdetails}
                        pagination={{
                          defaultCurrent: state.page,
                          defaultPageSize: state.pagesize,
                          showSizeChanger: true,
                        }}
                        onChange={handleTableChange}
                      />
                    </Panel>
                    <Panel
                      header="Bank Details"
                      key="16"
                      disabled={!showVendorBillingDetails}
                    >
                      <BankDetailsVendor
                        gstValue={state.gst_no}
                        VendorId={postGeneratedVendorId}
                        CompanyId={postGeneratedCompanyId}
                        setBankDetailId={setBankDetailId}
                        bankdetailId={bankDetailId}
                        setShowPaymentCollapse={setShowPaymentCollapse}
                      />
                    </Panel>
                    <Collapse>
                      <Panel
                        header="Payment"
                        key="5"
                        disabled={!showPaymentCollapse}
                      >
                        <PaymentMyVendor
                          VendorId={postGeneratedVendorId}
                          paymenttermsId={paymentTermsId}
                          setPaymentTermsId={setPaymentTermsId}
                          setShowPaymentPersonReleasedField={
                            setShowPaymentPersonReleasedField
                          }
                          gstVendorId={gstVendorId}
                          gstValue={gstValue}
                        />
                      </Panel>
                    </Collapse>
                    <Panel
                      header="Whom To Intimate When Payment Is Released"
                      key="6"
                    >
                      <WhomToIntimateVendor
                        disabled={!showPaymentPersonReleasedField}
                        VendorId={postGeneratedVendorId}
                        gstValue={state.gst_no}
                      />
                    </Panel>
                    <Collapse>
                      <Panel
                        header="Vendor Communication Matrix"
                        key="7"
                        disabled={!showVendorCommunicationCollapse}
                      >
                        <>
                          <Spin spinning={deliveryRateLoading}>
                            <Form
                              // onFinish={handleVendorCommunicationSubmit}
                              autoComplete="off"
                              ref={deliveryFormRef}
                            >
                              <Row gutter={[10]}>
                                <Col
                                  xs={24}
                                  sm={24}
                                  md={24}
                                  lg={4}
                                  xl={4}
                                  className="TextFeild"
                                >
                                  <Form.Item
                                    name="company"
                                    label={t("Company")}
                                    rules={[
                                      {
                                        required: true,
                                        message: (
                                          <Trans>
                                            {t("Please Select Company")}
                                          </Trans>
                                        ),
                                      },
                                    ]}
                                  >
                                    <Select
                                      placeholder={t("Select Company")}
                                      showArrow
                                      showSearch
                                      value={vendorCommunicationState?.company}
                                      name="company"
                                      optionFilterProp="children"
                                      onChange={(value) =>
                                        handleCompanyChange(value)
                                      }
                                    >
                                      {companyList.length &&
                                        companyList.map((item, key) => {
                                          return (
                                            <Select.Option
                                              key={key}
                                              value={item.id}
                                            >
                                              {item.name}
                                            </Select.Option>
                                          );
                                        })}
                                    </Select>
                                  </Form.Item>
                                </Col>
                                <Col
                                  xs={24}
                                  sm={24}
                                  md={24}
                                  lg={4}
                                  xl={4}
                                  className="TextFeild"
                                >
                                  <InputField
                                    name="name"
                                    label={t("label_person_name")}
                                    placeholder={t("pl_person_name")}
                                    rules={t("val_person_name")}
                                    prefix={<Name />}
                                    handleInputChange={
                                      handleInputChangeVendorCommunication
                                    }
                                    max={30}
                                  />
                                </Col>
                                <Col xs={24} sm={24} md={12} lg={4} xl={4}>
                                  <InputField
                                    name="designation"
                                    label={t("label_designation")}
                                    placeholder={t("pl_designation")}
                                    rules={t("val_designation")}
                                    prefix={<AddressLine />}
                                    handleInputChange={
                                      handleInputChangeVendorCommunication
                                    }
                                    max={30}
                                  />
                                </Col>
                                <Col
                                  xs={24}
                                  sm={24}
                                  md={24}
                                  lg={4}
                                  xl={4}
                                  className="TextFeild"
                                >
                                  <EmailField
                                    name="email"
                                    label={t("label_email")}
                                    placeholder={t("pl_email_2")}
                                    rules={t("val_email")}
                                    prefix={<Email />}
                                    handleInputChange={
                                      handleInputChangeVendorCommunication
                                    }
                                  />
                                </Col>
                                <Col
                                  xs={24}
                                  sm={24}
                                  md={24}
                                  lg={4}
                                  xl={4}
                                  className="TextFeild"
                                >
                                  <Form.Item
                                    name={`phone_number`}
                                    label={t("pl_ContactNo")}
                                    pattern={"/^d{12}$/"}
                                    rules={[
                                      {
                                        required: true,
                                        message: (
                                          <Trans>
                                            {t("Enter Phone Number")}
                                          </Trans>
                                        ),
                                      },
                                      {
                                        pattern: /^\d{12}$/,
                                        message: (
                                          <Trans>{t("val_phone")}</Trans>
                                        ),
                                      },
                                    ]}
                                  >
                                    <PhoneInput
                                      className="PhoneSection"
                                      country={"in"}
                                      onChange={
                                        handlePhoneInputVendorCommunication
                                      }
                                    />
                                  </Form.Item>
                                </Col>
                                <Col
                                  xs={24}
                                  sm={24}
                                  md={24}
                                  lg={4}
                                  xl={4}
                                  className="TextFeild"
                                >
                                  <Form.Item
                                    name="vendor_matrix_steps"
                                    label={t("Communication Step")}
                                    rules={[
                                      {
                                        required: true,
                                        message: (
                                          <Trans>
                                            {t("Please Select Step")}
                                          </Trans>
                                        ),
                                      },
                                    ]}
                                  >
                                    <Select
                                      placeholder={t("Select Step")}
                                      mode="multiple"
                                      showArrow
                                      showSearch
                                      value={
                                        vendorCommunicationState?.vendor_matrix_steps
                                      }
                                      name="vendor_matrix_steps"
                                      optionFilterProp="children"
                                      onChange={(value) =>
                                        handleVendorMatrixStepsChange(value)
                                      }
                                    >
                                      {vendorMatrixSteps.map((item) => (
                                        <Select.Option
                                          key={item.id}
                                          value={item.id}
                                        >
                                          {item.name}
                                        </Select.Option>
                                      ))}
                                    </Select>
                                  </Form.Item>
                                </Col>
                                <ButtonField
                                  type="primary"
                                  className="SaveGradiantBtn mt-3"
                                  // htmlType="Submit"
                                  onClick={() =>
                                    handleVendorCommunicationSubmit()
                                  }
                                  label={t(btnDisplay)}
                                  loading={btnLoadingFile}
                                />
                              </Row>
                            </Form>
                          </Spin>
                        </>
                        <section className="grid-sec mt-5">
                          <Row className="tblheader">
                            <Col
                              xs={24}
                              sm={24}
                              md={24}
                              lg={24}
                              xl={24}
                              className="tbl-action"
                            >
                              <div className="searchwrp">
                                <Space direction="vertical">
                                  <Search
                                    prefix={
                                      <img
                                        src={SearchIcon}
                                        alt="SearchIcon"
                                        className="SearchIcon"
                                        width={22}
                                      />
                                    }
                                    placeholder={t("pl_search_list")}
                                    onChange={searchCallbackDelayed}
                                    style={{
                                      width: 250,
                                    }}
                                  />
                                </Space>
                              </div>
                              {/* {selectedRow.length > 0 && (
                                <Popconfirm
                                  className="action"
                                  title={t("pop_title")}
                                  okText={t("pop_ok")}
                                  cancelText={t("pop_cancel")}
                                  placement="left"
                                  onConfirm={() => handleArchive()}
                                >
                                  <ButtonField
                                    className="BlueShadowBtn"
                                    type="primary"
                                    htmlType="button"
                                    label={t("pl_archive")}
                                  />
                                </Popconfirm>
                              )} */}
                              {/* <Tooltip
                                placement="topLeft"
                                title="Archived Records"
                              >
                                <Link to="/vendor-document/archive">
                                  <Archiveicon />
                                </Link>
                              </Tooltip> */}
                            </Col>
                          </Row>
                          <Table
                            // rowSelection={rowSelection}
                            columns={columnsCommunicationMatrix}
                            rowKey={(record) => record.id}
                            // dataSource={companycolumnsCommunicationMatrix}
                            dataSource={vendorCommunicationList}
                            loading={loading}
                            pagination={{
                              defaultCurrent: stateTable.page,
                              defaultPageSize: stateTable.pagesize,
                              showTotal: (total) => `Total ${total} items`,
                              showSizeChanger: true,
                            }}
                            onChange={handleTableChangeVendorCommunication}
                          />
                        </section>
                      </Panel>
                    </Collapse>
                    <Collapse>
                      <Panel
                        header="Vendor Document"
                        key="8"
                        disabled={!showVendorCommunicationCollapse}
                      >
                        <VendorDocumentField
                          VendorId={postGeneratedVendorId}
                          // communicationMatrixId={communicationMatrixId}
                          // setCommunicationMatrixId={setCommunicationMatrixId}
                          gstVendorId={gstVendorId}
                          gstValue={gstValue}
                        />
                      </Panel>
                    </Collapse>
                  </Collapse>
                  </Form>
                </div>
              </div>
              <div className="stepsFooter">
                <Button
                  cursor="pointer"
                  type="secondary"
                  className="primary"
                  onClick={() => navigate("/vendor")}
                >
                  Previous
                </Button>
              </div>
            </Content>
        
          <Modal
            className="ModelPopupSec"
            title={"Verify Email"}
            open={isModalOpen}
            onOk={handleOk}
            onCancel={handleCancel}
            closable={handleCancel}
            wrapClassName="modal-wrapper"
            keyboard={false}
          >
            <VerifyOtpModal
              handleCancel={handleCancel}
              setVerifyEmailButtonView={setVerifyEmailButtonView}
              OTP={OTP}
              setOTP={setOTP}
              state={state}
              setState={setState}
              setMinutes={setMinutes}
              setSeconds={setSeconds}
              seconds={seconds}
              minutes={minutes}
              handleSendOtpEmail={handleSendOtpEmail}
              setVerificationResultEmail={setVerificationResultEmail}
            />
          </Modal>
          <Modal
            className="ModelPopupSec"
            title={"Verify Mobile"}
            open={isModalOpenPhone}
            onOk={handleOkPhone}
            onCancel={handleCancelPhone}
            closable={handleCancelPhone}
            wrapClassName="modal-wrapper"
            keyboard={false}
          >
            <PhoneOtpVerify
              handleCancelPhone={handleCancelPhone}
              setVerifyPhoneButtonView={setVerifyPhoneButtonView}
              OTP={OTPPhone}
              setOTP={setOTPPhone}
              state={state}
              setState={setState}
              setMinutes={setMinutesPhone}
              setSeconds={setSecondsPhone}
              seconds={secondsPhone}
              minutes={minutesPhone}
              handleSendOtpPhone={handleSendOtpPhone}
              setVerificationResultContact={setVerificationResultContact}
            />
          </Modal>
       
    </>
  );
};

export default MyVendor;
